import React, { useMemo } from "react";
import { connect } from 'react-redux';
import withStyles from "@material-ui/core/styles/withStyles";
import lodash from 'lodash'
import { plugins, crmValidator } from "helpers";
import { reportActions } from 'actions';


import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";
import TagsMultiSelect from "components/CustomSelect/TagsMultiSelect.jsx";
import RichEditor from "components/RichEditor/RichEditor.jsx";
import CustomCheckbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import CustomRadio from "components/CustomRadio/CustomInputRadio.jsx";
import Icon from '@material-ui/core/Icon';
import CheckCircle from "@material-ui/icons/CheckCircle";
import Cancel from "@material-ui/icons/Cancel";
import CancelIcon from "@material-ui/icons/Cancel";
import { Field, reduxForm, change, touch } from 'redux-form';

import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';


import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";
const moment = require('moment')

const imgStyle = {
    width: "200px",
    height: "200px",
    objectFit: "contain",
    outline: "1px solid #DCDCDC"
}

const THEME = createMuiTheme({
    ...MTablestyles,
    overrides: {
        ...MTablestyles.overrides,
        MuiTableCell: {
            head: {

                textAlign: "center",
                paddingRight: '24px'

            },
            body: {
                textAlign: "center",
                paddingRight: '24px'
            }
        }
    }
});

const FORM_NAME = "FORM_EARN_REPORT";

const form_validate = {
    "remark": {
        rules: {
            required: true
        },
        messages: {
            required: 'กรุณากรอก'
        }
    }
}

const validate = (values) => {
    const errors = crmValidator.validateByRulesList(form_validate, values);
    return errors
}

function formatTxnDate(isoString) {
  const dt = new Date(isoString);
  const pad = n => n.toString().padStart(2, '0');
  const day = pad(dt.getDate());
  const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const mon = monthNames[dt.getMonth()];
  const year = dt.getFullYear().toString().slice(-2);
  const hh = pad(dt.getHours());
  const mm = pad(dt.getMinutes());
  const ss = pad(dt.getSeconds());
  return `${day}-${mon}-${year} ${hh}:${mm}:${ss}`;
}

// 1. กำหนด list ร้านพิเศษและร้านโลตัสมอลล์
const specialShopList = [
    "แว่นท็อปเจริญ",
    "AURORA",
    "หอแว่น",
    "แว่นตามองเด้",
    "Bangkok Golds",
    "Gold Swiss",
    "Golden 99",
    "Goldmark Yaowarat",
    "Grolden 99",
    "JM เยาวราช",
    "YAOWARAJ GOLD",
    "เซ่งเฮง",
    "เซ่งเฮงเยาวราช",
    "เพชรทองนพรัตน์ 99",
    "เยาวราช เอ็มโกลด์",
    "ช่างทองสุโขทัย 2011",
    "ซี.พี.โกลด์ มาสเตอร์",
    "ทองเยาวราชโลตัสเกษตรวิสัย",
    "ทองเยาวราชกรุงเทพ",
    "ทองคำ เยาวราช",
    "บางกอกโกลด์ส",
    "ร้านทองเยาวราช",
    "ร้านทองคำเยาวราช",
    "ร้านทองสุพัตรา",
    "ลินดา เจมส์",
    "วาริชจิวเวลรี่",
    "ศรีทอง จิวเวอรี่",
    "ห้างเพชรทองเซ่งเฮง",
    "ห้างเพชรทองเยาวราช ตราย่าโม",
    "ห้างเพชรทองโชคเจริญเยาวราช",
    "ห้างเพชรทองไทยภัณฑ์ มุกดาหา",
    "ห้างทอง เอเอ เยาวราช",
    "ห้างทอง ทองคำ เยาวราช",
    "ห้างทองเพชรทองใบ",
    "ห้างทองเพชรทองใบเยาวราช",
    "ห้างทองเยาวราช",
    "ห้างทองเยาวราช ๙",
    "ห้างทองเยาวราช ทองดี",
    "ห้างทองเยาวราช๙ นครอินทร์",
    "ห้างทองเยาวราชเอเชีย",
    "ห้างทองเยาวราชกรุงเทพ",
    "ห้างทองเยาวราชดำเนิน",
    "ห้างทองเยาวราชทองคำ",
    "ห้างทองเยาวราชทองดี",
    "ห้างทองเยาวราชมังกร",
    "ห้างทองเยาวราชมังกรคู่",
    "ห้างทองเยาวราชมังกรทอง",
    "ห้างทองเยาวราชศรีนครินทร์",
    "ห้างทองเยาวราชสินทวี",
    "ห้างทองเยาวราชสุพรรณหงส์",
    "ห้างทองเยาวราชออมทอง",
    "ห้างทองแม่กิมหงส์",
    "ห้างทองแม่กิมหงส์เยาวราช",
    "ห้างทองแม่ทองสุก",
    "ห้างทองแม่ทองสุกเยาวราช",
    "ห้างทองแม่อุไร",
    "ห้างทองโชคเจริญ เยาวราช",
    "ห้างทองใบกรุงเทพ",
    "ห้างทองไทย",
    "ห้างทองไทยดี 5",
    "ห้างทองกรุงเทพเยาวราช",
    "ห้างทองกวงฮะเฮงเยาวราช",
    "ห้างทองคำเยาวราช",
    "ห้างทองจิรา",
    "ห้างทองชัยมงคล 4",
    "ห้างทองตั้งทองใบเยาวราช",
    "ห้างทองตำหนักทอง ๕",
    "ห้างทองทองเยาวราชไชน่าทาวน์",
    "ห้างทองทองโต๊ะกังกิมเฮง",
    "ห้างทองทองสวย",
    "ห้างทองที.ทองใบเยาวราช",
    "ห้างทองนริศรา",
    "ห้างทองบูรพา",
    "ห้างทองพรสุพรรณ",
    "ห้างทองพรสุพรรณ(เยาวราช)",
    "ห้างทองพรอนันต์",
    "ห้างทองพัฒนากร ทองเยาวราช",
    "ห้างทองพิพัฒน์",
    "ห้างทองภูเก็ต",
    "ห้างทองมังกรเยาวราช",
    "ห้างทองรัตนพันธ์ทองเยาวราช",
    "ห้างทองศรีสุวรรณ",
    "ห้างทองสุพัตรา",
    "ห้างทองหยงเตียน",
    "ห้างทองหวังโต๊ะกังเยาวราช",
    "ห้างทองหวังทองดี",
    "ห้างทองหวังอยากมี",
    "ห้างทองอยากมีตังค์",
    "ห้างทองอรสา 5",
    "ห้างทองอลงกรณ์",
    "ห้างทองอึ้งเฮงหลี",
    "ห้างทองอุดร-สกล"
];
const lotusMallShops = ["A Wash Station", "Bun", "Colla Tea", "Daily Belly Pork", "DTAC", "DTN", "Dunkin'", "MUMUCHA", "Nut Candy", "Shabu station", "TRUE", "โทริมารุ", "กระเพาะปลาเยาวราช", "ตันหยง คาเฟ่", "วราภรณ์ ซาลาเปา", "สารพัดตำยำแซ่บ", "สารพัดลูกชิ้นทอด", "อื่นๆ", "88 Diamond", "BaNaNa", "Be Be Phone", "Cafe' Amazon", "Chester’s", "Dairy Queen", "FAXLITE", "KFC", "Kids Universe Toys Shops", "Lollipop", "Mamee Store", "MK Mobile", "MR. D.I.Y.", "Na Gift Shop", "So Jun Grill", "T.H เซอร์วิส", "Watson's", "เมธา โมบาย 2", "จอม Service", "น้ำผึ้งโมบาย", "นิวฟิล์มประดับยนต์", "พาวเวอร์โฟน", "รัชพลการแว่น", "ร้านปลาสวยงาม", "ล้านน้ำ by Coffee Park", "ลูกชิ้นสมหวัง", "สบายโฟน", "Adamas", "Auntie Anne's", "Bam Phone", "BATA", "B-Quik", "Cherilon", "CSC", "Cute Press", "D'ARTE Shoes & bags", "Food Court บัตรเงินสดชนิดไม่แลกคืน ", "Galaxy Plus", "JJ Mobile", "Kyodai Sushi", "Major Cineplex", "Mc Jeans", "Mikucha", "MK Suki", "Mobilio", "S&P", "Save Drug", "Skippy Land", "TAYWIN", "เรือนไทย massage", "เฮียนัทโฟน", "แว่นท็อปเจริญ", "ชนะทรัพย์โมบาย", "มนุษย์ชา", "วัวล้วนๆ", "สามเหลี่ยม คาร์แคร์", "AURORA", "AIS", "Camera Center", "Der Export", "Diamond Coffee", "Fiber Optic", "For U", "IT City", "Joy Phone", "ME Waffle", "Middle cat bubble tea", "Mind candy", "Modish Massage", "New Phone", "Ochaya", "Pasta Kitchen", "Potato Corner", "Queen sweet", "Samsung", "SE-ED Book", "Sounthern Coffee", "Stamp Mobile", "Swensen's", "Teddy Zero", "The Hair Cut & Nail", "VIP Organizer", "โชนัน", "กล้วยจันทร์", "คุณหนูอะโวคาโด", "ซูชิโชยุ", "รสละมุน", "หอแว่น", "3BB Fiber Optic", "99 Accessories", "A II Z", "Aesthetics Clinic", "Beautrium", "Bebe Phone by Com7", "BODY GLOVE", "Bonjour", "Echo", "Echo BonBon", "Echo Vstadioke", "Eco Wash Society", "Fhathier ฟาเทียร์", "Funky Fries", "HACHIBAN", "Hollywood Studios", "Hop Chafe’", "IT GO", "J TECH", "Jay Mart", "Kansei Sushi", "Love Eat&Play", "LOVE N&N", "Lucky Suki&BBQ", "M&G Stationery", "MANCHESTER", "ME25IT shop", "MI25KOI The'", "MI25Madame Marco", "MI25ตำรับไทย", "Mister Donut", "Mixue", "montipa", "Moshi Moshi", "Oppo", "ORIENTAL PRINCESS", "Realme", "SABINA", "Shabushi", "Studio 7", "Tea Cha Café", "THE FACE SHOP", "The Kiss", "The Pizza Company", "TOTAL", "Yoguruto", "เจียงลูกชิ้นปลา", "เพนนา", "โรงงานหมอเส็ง", "จิตตนาถ นวดเพื่อสุขภาพ", "ชาตรามือ", "นิตยาไก่ย่าง", "บีไบร์ทโฟน", "ประดับยนต์", "ฟอร์โฟน", "ร้านฟาร์มคอฟฟี่", "Best Phone", "FIVE STAR", "Fun Pavilion", "Mattrees City", "Pan Shop", "Pizza Hut", "Redone", "Sushi Like", "Telewiz", "เก่งจังโมบาย", "โก้ โมบาย", "กุ้งเพ้นท์เล็บ", "ผึ้งน้อย เบเกอรี่", "วันเดอร์โฟน", "สุกี้ตี๋น้อย", "อภิเศรษฐ์ นวดเพื่อสุขภาพ", "ออโต้โฟน", "BOWLING", "Fit  Auto", "Health up", "Inthanin", "KK Phone", "Klean Square", "KT OPTIC", "Mc Donald's", "Play Z", "Strawberry Club", "Sushi Mana", "TuTa Telecom", "Wacoal Studio", "แซ่บเลย", "โฟนชอป", "ไพบูลย์นวดแผนไทย", "ตำรับไทย", "ปาร์ตี้ช็อป", "40 Phone", "BK Mobile", "Candy Land", "CJ Mobile", "Mix&Match Shop", "Morfin Shabu", "tg", "TK Phone", "TP Phone", "Waffle Day", "เก๋โมบาย", "เรือนไม้นวดเพื่อสุขภาพ", "แสนดี ฟาร์มาซี", "ไอซ์ ประดับยนต์", "กี้โมบาย", "ซีซั่นโฟน", "ดีเอสจี มอเตอร์", "บ็อบโมบาย", "ลิกอร์ บ้านขนม", "ลูกชิ้นฮ่องเต้", "วริศรา ผ้าไทย", "วินเปาเปา", "ศศิณา", "อมรศูนย์รวมอะไหล่", "Bar-B-Q Plaza", "Chamichi", "COCO Walk", "Galaxy", "Lofts", "Meena Shop", "MOMO", "Mr.Bun", "OWL CHA", "Phone Shop", "Poligan", "Rondo", "SA Nails & Eyelash Pretty", "Telestar", "ชาตักวุ้น", "ดอยคำ", "บ้านฟันฟ้า ทันตกรรม", "สบายกาย นวดแผนไทย", "BFKT", "HIGH LIGHT", "Nobicha", "Slimming secrets", "The Egg", "Tiger Land", "True coffee go.", "ซาลาเปาทับหลี", "50 Fly", "CIasse", "Clean Station", "Go Kart", "Miracle Coffee", "Smoothies Pe Ta", "Thep Telecom", "แว่นตามองเด้", "ผ่องพรรณ", "พลอย นวดแผนไทย", "ร้าน เดอะเนล", "ลูกชิ้นแป๊ะ", "AKITA CHA", "Coffee Today", "Decathlon", "Diva&Homme", "Go pizza", "Health Mates", "KAMU", "Kidzoona", "KN Shoku Sushi", "Minute Coffee By An Hour", "Miss sis", "NT Fiber Optic", "OZAWA RAMEN", "Polichem Smart", "Sanook Games Zone", "Santa fe' Steak", "Sovegan", "Starbucks", "The Great Clinic", "UTime Fitness Studios", "Yayoi", "เนื้อแท้", "โต้ว น้ำเต้าหู้", "ข้าวหมกไก่", "คลินิคทันตกรรมเดอะเบรช", "ตำมั่ว", "นวดรื่นฤดี", "บาร์ขนมจีน", "108 Drug Express", "A.T.GOODS", "Apex Sketing Academy", "Aphroditety Clinic", "AT Phone", "Big Camera", "Boots", "Cha Nail@Salon", "Claase", "Click Robot", "Davie Jones", "EGV", "EV House", "Eye Class", "G.T.Mobile", "J J Phone", "Joe Music", "KIKI BABY", "Krit Fight Club", "Le Nails", "Mix&Macth Shop", "PP Phone", "PRO CLEAN", "Remax", "Scholl", "TG Fone", "UT", "โฟล์คโฟน", "จีระพงษ์ ขนมไทย", "ซูชิมั้ย", "ตาลโฟน", "นิคเทเลโฟน", "บรรจงทรัพย์มอเตอร์โชว์", "ปังเปา", "มาร์วินโฟน", "ร้านเฟอร์นิเจอร์สวย By ภิญญานนท์", "รีแล็กซ์ นวดเพื่อสุขภาพ", "ศูนย์ผ่อนและซ่อมมือถือ by คุณหญิงโฟน", "สุรศักดิ์ โมบาย", "Ajuma Shop", "ECC", "Great Music", "HAIR DECOR", "MS SNACK", "My Studio & Service", "One Power ยูนิฟอร์ม", "Satin", "Shabu Chain", "SOFA by SB Furniture", "ST Fashion", "เจ เอ บิวตี้ช็อป", "เรือนละมุน", "ไอศกรีมมหาชัย", "ดีเกตุตกแต่งรถยนต์", "น็อต@ไมค์", "ภัตตาคารอาหารญี่ปุ่นฟูจิ", "ร้านเครื่องดนตรี", "ลองดูโฮม", "หม่าม๊า ซาลาเปา", "Beauty Buffet", "Doo Dee Shop", "OFFICE MATE", "เฮง ปัง ปั๊ว", "หอมฉุย", "26 Mocyc", "88 mobile", "Anna Clinic", "AR Two Phone", "B9 Car Wash & Car Detailling", "Bake a wish", "BEAUTIFY", "Body Wax", "BOMBER DOG", "Bondz Clinic", "Bonus Phone", "Case town", "CAT Fiber Optic", "Character Studio", "Click robot’s", "COCO MONKEY", "DODOLOVE", "FINNE", "Fuji Restaurant", "FUKU", "HIS & HER", "Hokkaido milk", "I Star", "IT Money", "KANGZEN-KENKO", "Karikori", "Koji", "La' nail", "Lucky Mobile", "Middle cat", "Middle Cat Bubble Tea Premium", "Money Phone", "Mr.Sushi Restaurant", "N&B", "Nai-In Book", "Nice Florist", "OMI", "On Café", "One Mobile", "Pradap", "PS Mobile&Accessories", "Ramen A", "S swish", "S.Sap Phone", "Sukiya", "Sweet Soft", "Thai Lanna Massage & Spa", "The Outdoor Shopping Plaza", "The Sephora Clinic", "VKK&Son Used Car", "Wasana Shop", "With It", "Yves Rocher", "เครปสมหวัง", "โกลด์โมบาย", "โกลด์โมบาย2", "โซดา โมบาย", "โบนัสโฟน", "โรงเรียนยามาฮ่า ศรีนครินทร์", "ใส่เล่น", "กวดวิชามโนทัศน์", "ก้องคัทวินเทจ", "กาแฟสด Coffman", "ขนมไทยดอนหวาย", "คอสมา แคร์", "ชิมดู ซูซิ", "ดีที สติ๊กเกอร์", "ทันตกรรมปากน้ำ", "นิติพล คลินิก", "นิยมยีนส์", "ปันกัน", "มลหวานเย็นขนมไทย", "Black Canyon Coffee", "Daiso", "Edo Japanese", "Giordano", "HAAS", "Heritage Wellness Clinic", "Home Pro", "Konvy", "Mc Donald’s", "Milda", "MOMO CHA โมโม่ชา", "Organiq Nail & Spa", "SW Clinic", "Sweet Room", "The Volcano", "UNIQLO", "Yamazaki", "Yanata", "ชาคริต แฮร์ สตูดิโอ", "ร้าน Yanata", "AA Bakery", "Adapt Coffee", "INGCO", "Klean X", "Macces", "Phone Service", "Skechers", "Thai-Denmark Milk Land", "YuENPuEN", "โคตร ปั่น", "กาแฟพันธุ์ไทย", "คำนึง", "ตำลอกอ Seafood", "ปังสยาม", "ยอดเยี่ยมกระเทียมไทย", "Asia Society Fitness", "Bridgestone A.C.T", "Climb Central Bangkok", "Goldmoric", "H Sem", "M Phone เมนนี่โฟน", "Maru Waffle", "Min Hair Studio", "Mobile Plaza", "Nuengnatee", "Play Land", "Richesse", "Runway79", "So Grill and Shabu", "Stronghold Boardgame", "VMVK", "W car care", "Wine Connection", "ก๋วยเตี๋ยวเรือเสือหน้าหยก", "ทามะแทม เกมส์เมอร์ ช้อป", "บ้านสายฝน", "ยายละออ", "Anda Fashion", "Blossom Hair Stylist", "BS Factory Outlet", "Chili Chic Shoes", "Coffee World", "Fitteen", "FT Cuts", "GQ", "Gracci", "Healthy Drug", "Hop Café", "Joyliday", "King Bakery", "Kristie France", "KUMON", "Nail Bar @ Rama4", "Oh! Veggies salad", "O-li-no", "Pharmax", "Robo Think", "Smile Cooking Club", "Sushi Express", "Symphony Fiber Optic", "Wu Foo Shop", "Zenitoni", "ZhangLiang Malatang", "ก๋วยเตี๋ยวเรือพระนคร", "คลินิกการแพทย์แผนไทยโกมล", "ตะหลิว", "บอสเมดิรอยัล", "สุชาวดี นวดเพื่อสุขภาพ", "BB Phone", "Beam Beaw Phone", "B-K Mobiles & More", "Dego", "F&Y Phone", "Hair Indy", "Home Care", "Hot Pot Buffet Value", "Index Mall", "P&F Superdrug", "P&P Mobile", "PC Telecom", "PURE ONES", "Smiles r us", "WInnonie", "โรงเรียนดนตรี เลกาโต้", "จันทร์เจ้าโมบาย", "ชลลดา", "ร้านก๋วยเตี๋ยวเรือ", "Aicha", "Avocado with Manngo", "Coco Ichibanya", "Coffee Aday", "De Dream Clinic", "Easy Mobile", "FN Bag", "Gazelle", "Gon express", "KBBQ", "KOCO9", "LAKECOM", "M Phone", "Many Phone", "Milly Miley", "Mr.bao malatang", "One to two", "Perfect Smart Shop", "Secret Recipe", "Sho Ramen", "Urbun bao bao", "WELCOME", "Wondafruit", "กระทะเหล็ก", "ขนมแม่", "คลีนิคทันตกรรม", "ตั้งใจย่าง", "ร้านขนมจีบต้มเฮียเสก", "Aurora Diamond", "Big Bunny", "Cardboard Tavern", "Chersery Home", "De Wash", "DEEP ASH", "Dental Club", "Dr. Pong", "Galaxy Mobile", "LITRA Nail & Spa", "POP TEL", "ไข่หวานบ้านซูชิ", "Bangkok Golds", "BUDGET", "Fonink IT", "King Kong", "Koriya Cha", "LIVIA", "MC Nall Beauty", "NTK PHONE", "Total tool station", "ต้อม มือถือ", "มอร์นิ่ง เฟอร์นิเจอร์", "Boss", "Alots Phone", "Café AJiyoshi", "Eco wash", "LK Smart Phone", "Lucky Milk & Tea", "PookPeek Shop", "TONG GADEN", "TSN จานชาม เซรามิค", "โชว์รูมรถมิตซูบิชิ", "พูจอง คลินิกเวชกรรม", "ร้านนวดณราวดี", "Diamond For You", "CA.body wax&spa", "COCKPIT", "Quickly Coffee", "เจริญทรัพย์เฟอร์นิเจอร์", "นิวไลท์ คลินิก", "Diamond Gems", "Avocado Café", "Bellinee's", "Bike Man", "Dao Gashapon", "We Drink", "Whitehouse Dental Clinic", "โรงเรียนรมณียศิลป์", "ง้วนหลังวัง", "ชาพะยอม", "DILAVIE", "ภูตะวัน นวดเพื่อสุขภาพ", "ยอดชา", "ราเมน ฮาบุ", "สไมล์โฟน", "อาวล์ โฟน", "Arabitia", "Baby Toys", "curry house", "First Class Jewelry", "ISBN", "K.C.Accessories", "Med shine Clinic", "Missy BAM The nail house", "Momo Cha & Crape", "P&F SMOOTH LIFE", "Sri Fah", "Vanilla Prince Cafe", "Wizard", "Gold 4 Cash", "Phoenix", "Tyre Plus", "โซเฟีย คอสเมติค", "โอกาเนะคิน ซูชิ", "กู๊ดโฟน", "ตุนท์ ชาบูม", "Gold Swiss", "Golden 99", "อีสานโมบาย", "Amor", "BKK Mobile", "PonMaree Bakery", "Smile memory dental clinic", "คลั่ก ก๋วยเตี๋ยวเรือ", "มณีรัตน์", "9 Shabu", "B2S", "Boonchai Mobile", "chapakyoon", "Mistine", "The nail space", "ก๋วยเตี๋ยวเรือศิวิไล", "ฟรุ๊งฟริ๊ง", "สบาย", "Goldmark Yaowarat", "Bangkok Medical Lab", "CHALLENGER", "Coolboyz", "Design 10", "Gateaux House", "I Mobile", "Lucky BBQ", "Lucky Suki", "MakeMe Cute", "Nineties Design", "Rallets", "SEVEN DAYS OPTIC", "SHINKANZEN SUSHI", "TC Teletac", "Waffle Me", "ก๋วยเตี๋ยวไก่แม่ศรีเรือน", "วรรธนา ขนมไทย", "Grolden 99", "อวตารคลินิก", "อุมาพร นวดเพื่อสุขภาพ", "3 J Phone", "AJ Phone", "JM เยาวราช", "Cotton House", "Latex Pillow", "Lovely Nails", "Mareeya Clinic", "Nevada Pizza", "NT Mobile", "NT Mobile Service", "YAYA Phone", "Zoom mobile", "โมดิท มาสสาจ", "โอเด็ด", "โอทอป ไทยแลนด์", "ชอบชา", "Jubilee", "Citurs Pharmacy", "CSDC Dental Clinic", "Curry Puff Coffee", "Make me cute", "Prem coffee", "Pretty Me Up", "Queen of nails", "Ryota Shabu & Suki Buffet", "VIVO", "BB Mobile", "Beer Mobile", "T-NET PHONE", "ผ่อนไอโฟนโลตัส", "มอเตอร์คลีน", "Family Phone", "Image Hair Sutdio", "Majime มาจิเมะ", "Moya Vintage", "Nobita moji", "Oishi Biz ToRo/โออิชิ บิซโทโระ", "P&Y Angle Nail Art", "POLI CHEM", "We Smile Clinic", "บัวทิพย์นวดไทย", "หญิงเล็กโมบาย 4", "JUVELA", "Khonsilver", "DECO", "Fx Telecom", "Kids universe", "P Lifestyle Acessories", "Pimmy Hair Solon", "Thailand Beauty Center", "The Muse Clinic", "The Premire Clinic", "Tian Mi Tang", "Toys Land", "UDA Auto Glass", "คังเซน", "ภูริตา", "สบายใจ", "KT Diamonds", "Kyn_123 Jewelry", "ออลเวย์ส สไมล์", "99 Haircut", "All About", "AP Phone 1", "Ms. Pawnshop", "Chang Ton Haircut", "CheckGo Lab", "Echo Karaoke & Games", "GOGI SEKI", "Hair Studio", "I Am Cha", "I Care", "Kitkatroom Lash", "Kitkatroom Nail", "LB Beauty Lab by ครูทราย", "Mordern Phone", "MR.Phone", "MUSIC SOLO", "New Mobile", "Shinjuku Outlet", "SJ Phone", "Vital plus clinic", "เฟียเร่", "เอพีโฟน2", "โรงเรียนเมษ์วดีการดนตรี", "กองจู ปิ้งย่าง&ชาบู", "คลินิกทันตกรรมเมตาเดนเต้", "จรูญประดับยนต์", "จ๊ะแอนด์เจ Phone", "ดิอายวิชั่น", "ตัดผม Easy Cut", "ปอ.อุบล", "มาวิน Mobile", "มิเกล เล็บเจล by คุณมายด์", "ร้าน Kim การแว่น", "ร้านแว่นตาไทเทเนี่ยม", "วัลโมบาย", "ศิรินวดเพื่อสุขภาพ", "สหมือถือ", "NARA GEMS", "Nimsilver", "ORIO Jewelry", "อิส แอม อาร์ เอดูเคชั่น", "All In Beauty & spa", "ALTOGETHER CLINIC", "Picha Gems", "Auto 1", "BG Gashapon", "Plemi Jew", "Max Beef", "Salmon For You", "The Duck cha", "Zuperlee Shop", "นิวเคลียร์ โมบาย", "Premium Diamond", "RADIANY", "Book meena studio", "Kesinee Nail & Spa", "MakeSure Knowledge Center", "MATTERESS CITY", "Power Buy", "The Light Clinic", "TOT", "Uni Bra", "Uni Hair Style", "เฉียนเปา", "โรงเรียนอบรมช่างซ่อมนาฬิกา", "กาแฟชาวดอย", "ข้าวมันไก่เสนา", "สราลัย นวดแผนไทย", "Shinee Jewellery", "168 Toy", "Createmake and play", "Hair Wave by ANAN", "Nu Mobile", "PAO", "Pharmacy", "Summer toy", "The Mobile Studio", "โฮม โปรดักส์ เซ็นเตอร์", "บ้านนวดมายเฟรนด์", "ร้านนวดมายด์เฟรนด์", "TD Jewely", "Autobacs", "U Diamond", "Healthy Mates", "KK Accessories", "KT Mobile", "Nail Shop", "T Mobile", "ต่ายโมบาย", "ทเวนตี้ Five Phone", "ร้านนวดไม้งาม", "YAOWARAJ GOLD", "เซ่งเฮง", "เซ่งเฮงเยาวราช", "Bussaba", "Dakasi", "DDD Phone 2020", "HQ Travel&Store", "Jussmile", "Liberty Clinic", "Liberty Wellness & Spa", "Pan", "เบญญาภา จิวเวลรี่", "บลู เบดดิ้ง", "เพชรทองนพรัตน์ 99", "หอมนวดแผนไทย", "หอมนวดไทย", "เพชรบัวสุวรรณ", "เพชรพลอยปุตรสตูล", "Anytime Fitness", "AS Mobile", "เยาวราช เอ็มโกลด์", "Carfair", "Clover Clinic", "Colla Crep", "Curl & Cut", "Dresstinie", "ECC Lotus Bang yai", "GENCODE", "Hermosa Exclusive Clinic", "K&B Mobile", "M Mobile", "MATH WIZARD", "Mercury clinic", "MI", "Nail Kiss", "Nikuya", "Rose’e", "Sankyuu Café", "Shabu Der", "Smile cheeze dental", "Uranus Clinic", "Wash Me Up", "YOU R", "Yuedpao", "โรงเรียนดนตรียามาฮ่า", "พฤกษา คลินิก", "ภูฟ้า", "มณฑมาฑ นวดแผนไทย", "ร้านเงินทอง", "ช่างทองสุโขทัย 2011", "ร้านผมคัต", "ร้านรองเท้าพี่หมี", "หยกสด", "ซี.พี.โกลด์ มาสเตอร์", "อนันทรา สปา", "Boss Phone", "Hara", "ID Beauty&Spa", "Wrangler", "ทองเยาวราชโลตัสเกษตรวิสัย", "ทองเยาวราชกรุงเทพ", "Fresh Car", "ทองคำ เยาวราช", "100 Shop", "Kiddy Land", "Kosupa Sushi Bar", "MOS Dental Clinic", "New i..Deal", "กอบัวเภสัช สาขาโลตัสจรัญสนิทวงศ์", "คำโตซูชิเบิร์นไฟ", "ร้านตัดผมวินเทจ", "สราญรมย์ก๋วยเตี๋ยวเรือ", "สวนผัก คาร์แว็กซ์", "Coffee Journey", "KAN OPTIC", "KK Mobile", "KNK Phone", "Loma mobile", "My Shop", "Nice Phone", "Place", "THE WIDE CLINIC", "เถ้าแก่เนี้ย ชาบู", "ข้าวมันไก่ไห่หนาน", "ย่างกรอบ ดูโอ้บูตะ", "@ Studio", "Charimma Clinic", "Mammy's Crape & Waffle Hongkong", "MEILI Cha", "Momo Cha & Crape", "Optical 88", "PL The Salon", "POPTEL", "กล้วยทอดอัมพวา", "ขนมกัญจ์เอง", "ตัวกลม", "วิภูษา นวดเพื่อสุขภาพ", "บางกอกโกลด์ส", "โคตรตำ โคตรยำ", "ศิริพร นวดเพื่อสุขภาพ", "Marucha", "Meena Phone", "PP GLASS CAR CARE", "เจ้ติ้ง ซาลาเปาทับหลี", "กษิดิศ", "ณัฐ โมบาย", "ยอดพิจิตร เทเลคอม", "Pan Derma Care Center", "Real Care Vision", "Waffle", "สถานีเครปบุฟเฟ่ต์ไส้เยอะ", "Akerach Shop", "Lovely Land", "PK CaFe’", "Takumi Kitchen", "เวียร์ Nail & Spa", "เอ็นแอนด์บีพิซซ่าเครป", "โบว์บิ้วตี้ซาลอน", "ดีดี", "สายน้ำดีไซ์", "มณีวรรณ์Jewelry", "ร้านเพชรไทยบูรพา", "ร้านทองเยาวราช", "COFFEE I DA", "Eye Level", "Habu Cha", "Rich Club", "ร้านทองคำเยาวราช", "มุมสบาย นวดแผนไทย", "รักษ์หน้าคลินิค", "ร้านชามาจิเมะ", "Bump Coffee", "NK Phone Service", "Unity Center", "HAIR 2 STYLE", "M Series", "One Telecom", "P&P Sushi", "The Ultimate 789", "Tooth Station", "ณัฐมนมือถือ", "ศุภธารา นวดสบาย", "BK Phone", "COMMO", "Ecowash", "Hair Wave", "My Phone", "เพื่อนโมบาย", "กาแฟมวลชน", "กาจอก น้ำผึ้งนมสด", "จำหน่ายมือถือเเละอุุปกร์มือถือ", "ฟ้าใส", "ภูตะวัน", "AP Mobile", "AT 888", "Autoclik", "C-COOL", "Fantasy Hair & Nail", "JJ Lucky Shop", "Miniso", "Moma'sBubble Tea Bar", "OKSmile Dental", "PEAYIM", "PP Fix and service", "Redkondee", "RTU Mobile", "SP Service", "V.I.P. PHONE", "V-Vipphone", "เอที . 888 โมบาย", "ตุ้มซูชิ", "ทิพย์มาลี นวดเพื่อสุขภาพ", "ธันยาภัททร์โมบาย", "ร้านใส่เล่น", "วี.เอ็น โฟน", "Huawei", "ดาราคลินิก", "Echo Games ", "Pharmaway Plus", "Smile Shop", "ร้านทองสุพัตรา", "ลินดา เจมส์", "Beaver Auto Service", "BEAVER CAR WASH", "ชัยวัฒน์โมบาย", "วาริชจิวเวลรี่", "ศรีทอง จิวเวอรี่", "289 gadget", "BOND SHOP", "Coscen", "ห้างเพชรทองเซ่งเฮง", "Lavender Hair & Nails", "Lavender Store", "Pop Up ", "เจนาย", "ร้านนวด เฮง เฮง กระบี่", "ห้างเพชรทองเยาวราช ตราย่าโม", "ห้างเพชรทองโชคเจริญเยาวราช", "ห้างเพชรทองไทยภัณฑ์ มุกดาหา", "ห้างทอง เอเอ เยาวราช", "Bank ประดับยนต์", "Samart Service", "Say leb", "The Black Dragon", "V.I.P. Mobile", "กระเป๋าสเตฟาน", "อิ่มหมีพี่มันส์ บุฟเฟ่ต์ชาบูปิ้งย่าง", "All Brand", "ห้างทอง ทองคำ เยาวราช", "Baby Link", "Farm Coffee", "ห้างทองเพชรทองใบ", "เบอร์รี่ เจ้มจ้น", "รอยัลโฮม", "Phone Phone", "Real Me", "โคตรแซ่บทะเลดอง", "มิสเตอร์คอนเนค", "ห้างทองเพชรทองใบเยาวราช", "ห้างทองเยาวราช", "By Aom Naka", "Champion Hair Studio", "Monkey shake", "N.C. Telephone", "Na Telephone", "Taekwondo center", "Tree Nail & Lash", "โรงเรียน High solution math school by tong", "โรงเรียนกวดวิชาอาจารย์ปิ่ง", "โรงเรียนสอนภาษาไอสไตล์", "ซาลาเปา เปาฟู่", "ต้นอ้อ", "ตี๋เล็ก ซาลาเปา", "นามาสเตโยคะ", "สถาบันดนตรีมิวสิคคาริซมะ", "สยามแหนมเนือง", "สุจริตโมบาย", "AMPCARE", "Design Printing", "J Fix", "JJ GAME", "LIKES", "NU Sports Adder", "Oppo by Oppo Thailand", "SHEEP SHOCKS", "Tooth Tone Dental Clinic", "Trendy Plaza", "เชิญ ปังปิ้งไส้ทะลัก", "โบว์แฟชั่น", "ตัวโต", "ทิฟฟานี่", "DCS Telecom", "KIKI", "Max Mobile", "สุดที่รักโมบาย สาขา 2", "475K โฟน", "F&F SOOTIES", "M&R Pharmacy", "Yes Coffee", "ทัช เทเลโฟน", "นิธิภรณ์โมบาย", "พีแอนด์เอ็นพลัสคาร์แคร์", "ร้านเสื้อผ้าแฟชั่นฮิปฮอป", "ฮิโยโกะ", "Amata Coffee", "Cafe De Iyara", "Focus", "ZIIMME Beauty and Spa", "เลิฟเลิฟโฟน", "แดนโมบาย", "จีโฟน", "ร้านนวดอินทนิล", "ห้างทองเยาวราช ๙", "ห้างทองเยาวราช ทองดี", "555 Mobile", "888 Shop", "99 Phone", "apple store", "Gift Land", "LUCKY STORE", "Magic Hair&Nail", "Power Clean", "Thank You Shabu", "เสื้อผ้าlady", "เสื้อผ้าคุณอ้อม", "ธนดลการแว่น", "ห้างทองเยาวราช๙ นครอินทร์", "ห้างทองเยาวราชเอเชีย", "MA-YA Cha", "บ้านครีม", "AT Car Care", "B Bright", "เสือโมบาย", "ก้าวหน้า มือถือ", "หน้าหมี ปิ้งย่าง พรีเมี่ยม", "Adventure", "ห้างทองเยาวราชกรุงเทพ", "Be bear", "Beauty&Best", "CLASSY", "Definite Shop", "DN Mobile", "KN Mobile", "Lady’s it", "Lavender", "PS Mobile", "Thungsong Telecom", "เกตุโมบายล์", "โตโยต้านครศรีธรรมราช", "โรงคั่วกาแฟทุ่งสง", "ไทยออโต้", "ตังค์ ตังค์ โมบาย", "บ้านขนม ช็อคโกแลค&แฟนตาซี", "บีเค เจริญโมบาย", "พงษ์ผ้าไทย", "พิซซ่าโคตรชีส", "ยากิปัง", "ยำใส่ใจ", "ร้าน วาสนา", "ร้านไทช็อป", "ร้านลูกปัดรองเท้าแฟชั่น", "ลูกชิ้นอิ่มสุข", "หมูย่างเฉพาะกิจ", "A mobile-PHONE", "Kawaii", "Twenty เอก เอส", "เอ็ม โมบาย", "กีกี้โมบาย", "บีบีกัน โมบาย", "พรรณราย คลินิก", "ละมุน นวดแผนไทย", "AB Inter Service", "FUN MUSIC", "PP กิ๊ฟช็อป", "Premium Phone Service", "Socute by Noodee", "Bear Bear Bear", "Cha Thai Ded", "Hatyai Sashimi", "Okucha", "เจริญผลโฟน", "ก้าวเกมส์เทเลโฟน", "คอมพิวเตอร์เซอร์วิส", "คุณชายอุปกรณ์มือถือและไอที", "ณิชา โมบาย", "ตั้งใจสื่อสาร2020", "รุ่งทรัพย์โฟน", "ลักษ์ 666 ช้อป", "Bingsu", "HiCha", "JF OPTIC", "KP Toys", "Medy Nail & Spa", "MIKU MIKU", "ธัญนรัตน์ นวดแผนไทย", "หนุ่มมิวสิค", "Chama", "Cut Work", "GMS", "Perfect Phone", "Pom Mobile", "SP MOBILE", "Sport Town, PAN SHOP", "เตี๋ยวบางกอก", "ขนมกัญจน์เอง", "ถูกอกถูกใจ", "ริชเชอร์ โมบายโฟน", "NAVA Mobile", "TROPICANA", "Zaleen Toys", "เกาะหมุย", "ลำไย นวดเพื่อสุขภาพ", "AKA", "Ama Cha", "Barbie blink clinic", "Brighter Smile Dental Clinic", "Design Phone", "Greatnail", "Hop Chafe", "J.I.B / Mine", "Jong Klom", "Levi's", "Miki Miki Shop", "Mitsubishi", "NB Barber Shop", "YOKI YOKI", "ไส้กรอกทอดนายฮั่ง", "ไอศครีมมหาชัย", "กาแฟสด", "ซูอา นวดเท้าเพื่อสุขภาพ", "ดาราShop", "นวดเพื่อสุขภาพ", "น้ำส้มเกล็ดหิมะ", "มิตรไมตรี สหคลีนิก", "ร้านปั่นแหลก", "ลูกชิ้นทิพย์", "ศิริประภาขนมไทย ๔", "หมูย่างเฉพาะสูตร", "Hello Jany", "I'm Service เอน.เจ.โมบาย", "Mobile Shop", "My Fantasy Zone", "NT Fone", "Sport Dome", "Total Beauty by His & Her", "เน็ตตี้โมบาย", "ไอศกรีม และเครื่องดื่ม", "กุญชรโฟนา", "คริซซ์พี เครป", "คุณไท", "ณ มล", "ทองวิลัยเครื่องนอน", "นีโอสุกี้", "บิ๊กอ้วน อาหารทะเลอบแห้ง", "สิงห์โต โมบาย", "ฮักผม", "9 Computer", "Bagushi", "Ice cream House", "Mobile Zone", "My Dear Bakery", "NN Car Care", "OK PIZZA", "WINNER CAMP คณิตศาสตร์ครูพี่เบส", "ไอทีแคร์", "ชาพญา โรตีชาชัก", "ซอลญ่า โมบาย", "นัสนีน โมบาย", "ร้านเล็กกิ๊ฟช็อปและของเล่น", "ร้านผ้าม่าน", "สบาย นวดแผนไทย", "อารีฟ เซอร์วิส", "อิสระ", "A&P Fashion", "Lava kup ถ้วยภูเขาไฟ", "Mega IT", "แอนฟิลด์ Acc", "ตุ๊กตา บิวตี้ ช็อป", "ทราวดีนวดแผนไทย&สปา", "Chick Cargo", "Concerto Music Academy", "Niseko", "SC Cosmetic", "ZAAP CLASSIC", "โต โตเกียว", "โรงเรียนกวดวิชาหทัยพร", "คัตสึยะ", "ฟิตทูฟลายสตูดิโอ", "Es-ki-mo", "Mr.Sushi", "M-Studio", "Sanook Game", "SF CINEMA", "SOMICHA", "Super Save", "Tee Heng", "W&T", "เครื่องหอม น้ำหอมอโรม่า เครื่องโอโซน", "แทนเจอรีน สปา", "กาแฟเขาทะลุชุมพร", "พี่นิก คาร์วอช 868 สาขา ชุมพร", "หัวมุม", "Hundred Style", "Jacob Phone", "เบนซ์โฟนเทค", "กรีนโฟน", "ธนกฤต โฟน", "นายหัว โรตีชาชัก", "ผ้าไทยอภัสรา", "Apple Plus+", "Chakura", "HP Phone", "IT Café", "Jaymart ioT", "Mobi by svpi", "N&N Phone", "The Richest Clinic", "Turbo Plus", "WUKONG MALA", "ล้านเซเล็บ เซเลบิตี้แนล", "สไมล์ ดีไซน์ เซ็นเตอร์", "ฮาโหล ปาดหน้า โฟน", "Boom Phone", "X-COM", "เซเลน่า คลินิก", "น้องรักบิ้วตี้มอล", "Oni Milk & Tea", "แก้วเพชรโฟน", "M-SHOP", "Smart", "TW Simply", "Boonchai", "Boss Music", "I SAY CUT", "Oicha", "Telewiz Plus", "ใบเงินโมบาย", "นราภรณ์ โมบาย", "รมย์ธีรานวดแผนไทย", "AM. Shop", "BP World", "BT Mobile", "Check in Toy", "Cheec-in Toy&shop", "EV BIKE PHUKET", "For U Mobile", "Gioarmy", "Lavender Hair & Nail", "MIKI MIKI", "Mongni Cafe", "PSD", "S.K.Mobile", "SPP Kanoom Siam", "Super Sport Fit Sport", "XL Mobile", "เวิร์ค คลับ มอเตอร์", "เฮงเฮง มือถือ", "โกเณร โฟน", "โบตัสโมบาย", "คลาสสิค โมบาย", "ตุ๊ก โมบาย", "ทานเล่น", "มรดกนวดแผนไทย", "ร้านเคสมือถือ", "TN Phone", "โทรศัพท์มือถือและอุปกรณ์เสริม", "โฟน สตูดิโอ", "ธนะดีฟาร์มาซี", "Clicks gadget", "Mcguiar's", "ORANGE FISH", "TN Solution", "ต้นรักเค้ก", "ตำโสเหล่", "B-Bright", "BELLATO", "Deal Mobile", "Design Image", "DM Phone", "Mommykidsland", "Nail 83", "One In One Shop", "PHONY SHOP", "Pizza Mana", "PP. Fashion", "Sawasdee Mobile", "SC Mobile", "VIP Mobile", "เสื้อผ้าเด็กฟ้าใส", "แก้วเจ้าจอมนวดเพื่อสุขภาพ", "ไอแอมกิ๊ฟช้อป", "คลินิกทันตกรรมฮาร์โมนี่", "ซูชิหน้าล้น", "ทิพย์แฟชั่น", "สถานีมือถือ", "Coffee Sweet", "IEC Easy Fix", "Kitchen Plus", "เกด&ไอซ์ โฟน", "เกาลัดเถ้าแก่เนี้ย", "ใบหม่อน", "นวดแผนไทย", "พิซซ่า อะโลฮ่า", "สักคิ้วคุณหนึ่ง", "อ๊อฟโมบาย", "อันนาโฟน", "อินเตอร์โมบาย", "อีซีโฟน", "72 Studio", "Stupi-Friesd", "T Tea Smoothie", "WAWA", "โอชายะ", "วุฒิ-ศักดิ์ คลินิก", "หนึ่งโมบาย", "Center Mobile", "IT Center", "Oppo by PN Phone", "Work Shop", "Auto Glym", "Kancha", "B.O.Mobile", "CHAODOI", "Darin Phone", "First Phone", "Lucky Phone", "N&N Mobile", "N.N.Mobile", "N.P Mobile", "Nasa Phone", "Quickly Plus", "Star Coffee", "TCW Telecom", "TOYAMA", "Wow Phone", "แจสซี่ คลินิก", "นารี เนล แอนด์สปา", "ม่วนแซบ อีสาน", "หัตทิพย์นวดแผนไทย", "Beanhound", "Bun Deli", "Fruit Party", "K Case", "Majime", "Meng นัว นัว", "NIKI", "SANTA FE' EASY", "Shinkanzen", "Smart Phone", "Stupid Fries", "ก๋วยเตี๋ยวมหานครา", "ข้าวผัดปูเมืองทอง", "หัวกระบาน", "DD Mobile", "Boonchai Telewiz", "Harlod’s", "Izekimo", "JT Phone", "Radar Telecom", "ไตรเทพ", "ไตรเทพ 1", "ลักษมิกร นวดแผนไทย", "Ice Monkey", "PD Mobile", "Double Cafe'", "จินจิน บิวตี้", "PP mobile999", "สำนักมือถือ", "9PK Auto Shop", "Advance Salon", "App Store", "ARMCHAIR MOBILE", "Arrow", "Fruit Station", "Ma’oishi", "MIA Shabu Buffet", "Mood", "OISHI RAMEN", "Sni Phone", "เก้าโมบาย", "เมืองโฟน", "เอส แอนด์ พี โมบาย", "แตงไท", "แอน มือถือ", "โฟโฟน", "กุ้งพลอยเพ้นท์เล็บสวย", "คลินิกทันตกรรมต้นส้ม", "ชินตา", "ต้นตาลช็อป", "นิยมเครื่องนอน", "บ้านโฟ", "พูต้าเชค", "พูต้าโฟน", "วิวบิวตี้แคร์", "AnnaArt", "Khun Pluem", "Mentor Medical Clinic", "Original Boat Noodle & Thai Food", "PK Mobile", "จินตนา", "ดิออนคลินิก", "ออมสินหยก", "อาร์ตประดับยนต์", "Baramyu", "D'oro", "Soft&Smile", "จตุวีร์ ขนมไทย", "Clinic", "Hi-Snow-Care", "My Klean", "Nail Room", "Salon", "ดลประดับยนต์", "อเล็กซ์โมบาย", "Domi Cha", "Patty Cut Beauty", "จัมโบ้ขนมจีบ", "มิตซู บีเอ็นที", "แม่วังสื่อสาร", "199 คลินิกเวชกรรม", "AD Phone", "CD Mobile", "Fantasia", "For Eyes Optic", "jejudony ปิ้งย่างเกาหลี", "north coffee", "PureO Profestional", "SASA Phone", "ST Mobile", "Uniss Store", "ทอยส์ ไทม์", "ร้านนวด", "Boseong Clinic", "MAPLE SUSHI", "Orucha", "P&P เสื้อผ้าเด็ก", "Snowwing", "T Phone", "Yes It Is Hair Salon", "เรนิต้า ระยอง คลินิก", "แป้งร่ำ", "โฮมโฟน", "จอยโฟน", "จอยโฟน999", "จัตตุพร มือถือ", "จัตตุพร มือถือและบริการ", "น้ำหอมดีว่า", "พีวีเอส โมบาย", "พุงชา ไก่ทอดเกาหลี", "มิตรโมบาย", "วาสนา เทเลโฟน", "9 Studio", "Bakery & Milk Tea Akicha", "Ninew เครื่องสำอางค์", "The Beat Shop", "WINNER SHOP", "สมหมายมือถือ", "@ T PHONE", "Chapayoon", "Hatyai Sashim", "KSR Spa Carclean", "Mixser Phone", "Mr.Gao", "Nail & Spa", "Nail Studio", "VIP telecom", "เนตั้ล โมบาย", "ไม้หมอน", "กระบี่โมบาย", "คลังโมบาย", "คันเซย์ ซูชิ", "พูพู่ โมบาย", "มุมโมบาย", "หลานตาชู", "first luggage", "Gadget Mate", "HQ Travel & Store", "Nail&Eyelash", "Peony Shop", "Phuket Car Wash", "Steak 88", "เพื่อนไอที", "จันทารา Massage", "BOSS Wash", "AP Mobile service", "Mr.Connect", "PR Phone", "Promakers Car Care", "โฟน โฟน", "โฟนโฟน", "ขนมกัญจน์เอง By Aroy", "Coffee House", "Do'Natnaill&Eyel", "Jeffer Steak", "Loving nails spa", "เฮงโมบาย", "ซี โมบาย", "บิ๊กแบงค์", "ปาร์ตี้ โมบาย", "พรรณรายนวดแผนไทย", "มาร์วิน โมบาย", "24 Com Service", "Perfect Shop", "The Outlet 24", "เฮง เฮง เฮง โมบาย", "ใต้ฟ้า เทเลโฟน", "จินดา นวดแผนไทย", "ดีดี โมบายด์", "ที.โฟน.โมบาย.แป้ง", "ทีพี โมบายล์ โฟน", "ยูกิ ซูชิ", "รับทรัพย์ โมบาย", "Bake Man Handsome", "Echo Games", "Mobile", "Lookpat Nail&Eyelashe", "ZEASUN COSMETIC", "ศุภาลัย", "Roll House", "WHAT A SHAKE", "Yellow Bean", "เกรทเตอร์โมบาย", "ชูการ์โฟน", "มาร์โมบาย", "Chakono", "เจไวร์เลส", "ดี โมบาย", "ร้าน ไอที โฟน", "A TEN Mobile", "Fruit Land", "MTAC Phone", "PP CASE", "Quick Lane", "Smile One Dental Clinic", "Twin Mobile", "หม่าล่า BBQ ห่าวซือ", "หมูกระทะ ตำมั่ว", "หวาน-หวาน-เย็น-เย็น", "100 Case", "Oppo Shop", "TEAM", "อั่งเปาโฟน", "Shabu 111", "เดอร์นิวซี", "มิวสิคโฟน", "Tchaya", "Case 100", "เอ็มโมบาย", "หนึ่งเทเลโฟน", "NP SERVICE & BEAUTY", "ฟินอิชิ ชาบู", "Moboile Zone", "หมวยเฟอร์นิเจอร์", "DK Car Care", "My Dream", "เรณูขนมไทย", "โชคชัยสมาร์ทโฟน", "Natcha Shop", "NY Toys", "เคสโทรศัพท์และอุปกรณ์มือถือ", "Ice Me", "กาญจนา คาร์แคร์", "ซูชิอ้อมกอด", "Bee barista coffee", "BIZ-LINK24", "Happy World", "เบลโฟน", "ไทยเอลิแกนซ์ นวดแผนไทย", "ชานมกะหนมปัง", "น้องรักบิวตี้มอล", "ร้านมายด์", "Coffee นาย", "Green Phone", "ทวีสิน TS", "Aura blink", "Coffee Station By Max", "Game Fantasia", "Mind Gift Shop", "Monkey IT Service", "Pizza Cut", "อารีมิตร", "I Store", "Kami Hair Pro", "ต้นประดับยนต์", "B.Y.Nail & Eyelush", "คิดถึงเบเกอรี่", "ชีวารีนวดแผนไทย", "สุดใจโมบาย", "Galaxy 2 Shop", "ร้านล้างรถ Promaker", "ห้างทองเยาวราชดำเนิน", "ธนกฤต ไอโฟน โมบาย", "บอส คาร์วอช", "ห้างทองเยาวราชทองคำ", "อ้อมกอดซูชิ", "P&D Car Care Service", "ห้างทองเยาวราชทองดี", "Mongni Café", "ห้างทองเยาวราชมังกร", "Galaxy We", "Happy Land", "เอ็น พี โมบาย", "ชมภูเกษ", "บัดดี้โฟน", "ห้างทองเยาวราชมังกรคู่", "Moka Slove Coffee", "SP Phone", "Mora bakery Café", "T&T Shop", "ห้างทองเยาวราชมังกรทอง", "58 Wash", "เล็บเจล ณัชชา", "ร้าน 8 โมบาย", "App Phone", "ปาดังเบซาร์", "มากินเดอร์ คาเฟ่", "ENRICH XPLUS", "Lucky Land", "ชาวดอย", "ห้างทองเยาวราชศรีนครินทร์", "ห้างทองเยาวราชสินทวี", "Osaka", "Sweet Secret", "ดากานดานวดเพื่อสุขภาพ", "P&K CAR CARE SERVICE", "ต้าไท่ชาบู", "Fixfit", "G.N.N. Phone", "Jamile Studio", "Nannatta Shop", "NN Mobile", "Very Beautyful", "คูณทรัพย์", "น้ำใสเล็บเจล", "สามหัวบาร์เบอร์", "Beyond", "Echo Wonderland", "Hair Siam", "Hello", "Magenta Clinic", "MO MO Mart", "MOS Guitar", "Nik ชา", "สุพรรณิการ์นวดเพื่อสุขภาพ", "Addy Mobile", "After Tea", "ดาวโมบาย", "พิบูล ไทร์ เซ็นเตอร์", "อุ่นใจโมบาย", "Make up", "ต้อมเทเลโฟน", "Dr.Corner", "89 Mobile Fix", "Best Seller IT", "อุ่นใจทันตกรรม", "Apple shop", "KC Mobile", "Say mobile", "Snowy", "Yindee Cafe", "นะโม ช็อป", "Hug Tea", "Kan Nail & Eyeishes", "Madame Marco", "MANOI", "พลอยใส โมบาย", "Bee Phone", "iCase Fix+", "Meeso Clinic", "Pie Apple Store", "น้ำเหนือ Accessories 1", "น้ำเหนือ Accessories 2", "ร้านมิสเตอร์คอนเนค", "King Phone", "Toto mobile shop", "Care Max Pharmacy", "Echo Karaoke&Games", "Hom-cha", "Immate Clinic", "iosservice", "โนบิชา", "ซ่อมมือถือปทุมธานี", "พฤกษ์ภิรมย์ นวดเพื่อสุขภาพ", "A&P Vintage", "Porkaew Thai Massage & Spa", "ก๋วยเตี๋ยวต่อเรือ", "ณ เชียงคำ", "Aonny โมบาย", "Richly Phone", "พารวย มือถือ", "Momizu House", "ฟาร์มา เมด สาขาโลตัสบางบ่อ", "สมายโฟน 2", "AIS Buddy", "D.power", "Echo Aloha", "Peko Crepe & Tea", "Wonderful Nail", "Yeong Ju", "กชพรรณ คลีนิกความงาม", "ACAI HOUSE", "Bonchon", "Oranginal", "Salad factory", "Smile connect Dentol clinlc", "U-XO Hair Studio", "Chihuahua Pizza Kub", "Jinlong House", "Salapao Warapron", "WAN Hair Studio", "เฮฮาหมูกระทะ", "ไอยรา ฟาร์มาซี", "9 กุ้งอบ ปูอบ-สุกี้, ทองเนื้อ 9", "AKASHI", "Boost juice", "Dakasi Bingsu House", "Direct English", "EDU Wisdom", "Fitness Plus", "Guljak Topokki Chicken", "I’am Pizza", "JIB", "Jones' Salad", "KOUEN", "Look at me", "Mikka", "Minimelts", "Modernform", "Mo-Mo-Paradise", "New Era", "One hair Studio", "Paul", "Phoenix Lava", "Red Rabbit By Sexy Cow", "RoboThink&MathBond", "Rolling Roaster", "Saint Croissant", "Shizen Yakiniku", "Soundtaste Music School & Studio", "Sushi Plus", "Tamayaki", "The Chocolate Factory", "True Health Center", "VA'RIS BARBER CLUB", "Very clinic", "Volka wine", "wonderlingo by Little china", "YUMCHA STEAM KING", "Yuzu House", "YUZU SUKI", "เติมแมว by Homehug Cattery", "แมเนท เอสส์ นวดเพื่อสุขภาพ", "ขนมครกแม่เนตร", "คลินิกทันตกรรมไพร์มเด็นทอลโซลูชั่น", "คิดเช่นลาว", "นับ Kcal", "ราชาโตเกียว", "ลือชาโรตี", "วันสตูดิโอ", "สมใจ", "The Cheese Baron", "ONE MY SHOP", "กอเนื้อย่างเกาหลี", "บ้านย่า สเต๊ก เฮ้าส์", "ร้านโอกาเนะคิน ซูชิ", "2Sister Nail", "AMIRA SPA", "Apple Service", "AWN", "Etta", "HUDANOOR", "Joji Secret young", "SK CLINIC", "เจ เจ โฟนช็อป", "โปรเคส PRO CASE", "กาแฟหลงถิ่น", "ยูนิคแคร์ สเตชัน", "สตรอเบอรี่ คลับ", "หจก.เอส.โอ.โฟนเซ็นเตอร์", "Wonderful Carcare", "Blueberry", "Milk Cream", "MJ Mobile", "WAWA-I", "คอกาแฟ", "ดูดเพลิน", "ลูกชิ้นพิษณุโลกราม่า", "อิ่มจังชาบู", "199 Clinic", "ที่สุดชาบูและหมูกระทะ", "BB Land", "ชิบะชา", "Hiyoko Cha", "Krutid Coffee", "ที.โฟน.โมบาย", "น้องเก้า By พี่หนู", "น้องเก้าโฟน", "น้องโมบาย", "P&N car care", "มุกดาหารสื่อสาร 2", "มุกดาหารสื่อสาร1", "วันบิวตี้สกิน", "36 Car Wash", "Kaiju Shabu", "Penguin Milk Tea", "พีพีโมบาย", "NC Nails", "Inter toys", "Story Phone", "กรณ์ เซอร์วิช 1", "จัดเต็มโมบาย", "จัดหนักโมบาย", "ส้มส้มโมบาย", "We Coffee", "วิภาพรเกมส์", "Angel World", "24 Ink", "พอใจมือถือ", "69 Mobile", "Echo Fantastic", "Fashion", "MARWELL", "Mobile 1", "Mobile 2", "Runway", "ห้างทองเยาวราชสุพรรณหงส์", "ห้างทองเยาวราชออมทอง", "Bm โมบาย", "Peach Shop", "กะปุกริช", "ภูดินมือถือ", "ภูภูมิมือถือ", "ร้านยาสว่างเภสัช", "ออกัสโฟน", "Charming Nails by Mai", "CT Mobile", "เก้ยโมบาย", "เม็ดยา @ ท่าศาลา", "อ.โฟน", "AIS Buddy by IBIZ", "K&K Car Wash", "แนนนวดแผนไทย", "นกแก้วโฟน", "ฟ้าใสเทเลคอม", "ห้างทองแม่กิมหงส์", "ห้างทองแม่กิมหงส์เยาวราช", "AIS Buddy Exclusive", "GRIP by VS Car Service", "มียา", "ศรีอุปลีสานเฟอร์นิเจอร์", "ส้มตำ หรรษา", "ห้างทองแม่ทองสุก", "ห้างทองแม่ทองสุกเยาวราช", "AIS Telewiz", "AIS Shop", "กาแฟสด นายก้อง", "ห้างทองแม่อุไร", "ห้างทองโชคเจริญ เยาวราช", "dek Cha", "Duca'tim", "N&N น้ำหอมอโรม่า", "PK phone", "เคส 88 Shop", "โบซอง คลินิก", "ห้างทองใบกรุงเทพ", "เจริญทรัพย์มือถือ", "เอ็มเค โมบายโฟน", "ฟาร์มาพลัส", "สุภลักษณ์ มือถือ", "ห้างทองไทย", "ห้างทองไทยดี 5", "ห้างทองกรุงเทพเยาวราช", "PP Mobile", "สยามเทเลคอม", "ห้างทองกวงฮะเฮงเยาวราช", "Premium Cafe", "ห้างทองคำเยาวราช", "First Class Car Wash", "D-Chain", "T Mobile 2", "Wash Kub", "เล็บสวย By วาเลนน์เนลล์", "TEAM Galaxy Plus", "Lucky Toys", "NK istu", "Slimming Clinic", "กัมบอล", "ของใช้ภายในบ้านและครัวเรือน", "นครโมบาย", "ฟาสซิโน", "MS Advan Services", "NK.Mobile", "JP Computer", "เทเลโฟน", "เอ็มโฟน", "ดีเซอร์วิส", "ฟางโมบาย", "ห้างทองจิรา", "Dr.Car car wash", "Milyno", "ชาชักชาวเรือ", "หนึ่ง Street Food", "ห้างทองชัยมงคล 4", "ห้างทองตั้งทองใบเยาวราช", "ห้างทองตำหนักทอง ๕", "Tea time original", "Moma's Bubble Tea Bar", "ร้านล้างรถ จ้าวสัว การาจ", "เติมหวานเบเกอรี่", "ปังเย็น จัมโบ้", "A&A Lucky", "พี.เค.โฟน", "Chicky Chic", "NDO Sushi", "RICHY25", "แม่คำนึง", "โคตรเกี๊ยว", "ชีวารมย์นวดไทย", "มุมปั่น", "วันแฮร์สตูดิโอ", "อาหารตามสั่งป้ามาลี", "Rain Mobile", "Tasty Chifon Cake", "ไร่ปรียา", "S Service 1", "Infinity Optic", "Lady Beauty Studio", "Nom Mhee", "Noodle Garden", "ตัดผมชาย", "น้ำมะพร้าวปั่น Coco Smile", "มงคลโฟน", "ร้านผึ้งน้อย", "Thai vision การแว่น", "ชินจิชา", "ร้านสินค้า 20 บาทและเบ็ตเตล็ด", "บุญอุ้มโมบาย", "ร้านเคส", "ห้างทองทองเยาวราชไชน่าทาวน์", "ห้างทองทองโต๊ะกังกิมเฮง", "A&Y Beauty", "Chic Kogo", "LIFE@Curl", "Martial Arts Taekwondo", "เรือนแก้ว", "ดี - แซ่บ", "ต้าวหมีปั่น", "ร้านยาฟาร์มาเฟรน", "ห้างทองทองสวย", "น้องแฝดโมบาย", "ลอตเต้เทเลอคอม", "ห้างทองที.ทองใบเยาวราช", "ศักดิ์ไทยเภสัช", "ห้างทองนริศรา", "OTOP ", "T Service", "โบว์แดงเบเกอรี่", "ชายสี่บะหมี่เกี๊ยว", "จอยโฟน สาขา 2", "ฟาร์มาเซีย", "D-Mobile", "ห้างทองบูรพา", "เฟรนด์เทเลคอม", "Game Shop", "ซีซี เคส", "ศิริกิตติ์ ออฟติค", "ร้านมลขนมไทย", "121 Coffee", "ห้างทองพรสุพรรณ", "24 Coffee", "ผ้าม่าน", "ESSENTIAL", "Game Zone", "nono coffee & ice cream", "TOR BEEN", "มวยไทย", "เคเคโฟน", "ห้างทองพรสุพรรณ(เยาวราช)", "Little Time & Fashion", "เค้กอร่อย99", "โลตัสมือถือ", "ห้างทองพรอนันต์", "Modern Hair", "Phuket Fitness", "The Dentist Studio", "เนล สตรอรี่", "เฟิร์ส", "คีนยิมเทควันโด", "ลิงกินกล้วย", "บ้านบอล", "ปาดังเบซา", "ห้างทองพัฒนากร ทองเยาวราช", "ดลตรีกาล", "ห้างทองพิพัฒน์", "HEllo Mobile", "เนโกะเบ็ดเตล็ด", "บีบีแลนด์", "ห้างทองภูเก็ต", "เส้นวิเศษ", "โมบาย&เซอร์วิส", "T-Bone Steak", "Unicut", "โรงเรียนกวดวิชาจิรโชติ", "โรงเรียนจินตนการดนตรี", "โอม & เอสบีโมบาย", "มิตรไทยยิม", "ห้างทองมังกรเยาวราช", "9COM", "J9", "Green Smaile Shop", "เรนโมบาย", "Book Friend", "CHAHOM", "Kiddy World", "ไทยพลาสติก", "นวดฝ่าเท้า", "Monkey Jump", "เบอเกอร์รี่สตอร์รี่", "Sweet n soft", "Techno", "เคสตี้", "ปอปาเฮงดีโฟนช็อป", "โบกี้โมบาย", "SALAYA Drug", "ไบรท์ โมบาย", "ครอบครัว", "B.M.music", "Boom Fone", "ทับทิมเบเกอรี่", "Master Phone", "ร้านยาสิริเวช", "แมวน้อย", "บ้านเกมส์", "ที.อาร์.โมบาย", "T&O", "คู่ขวัญ", "ถุงเงิน", "มีโชค เอสเซสเซอรี่", "ชาวดอยคอฟฟี่ แอนด์ บั๊บเบิ้", "ห้างทองรัตนพันธ์ทองเยาวราช", "ออ อ้อน บ้านขนมและของฝาก", "Cutie Princess", "คิวตี้พริ้นเซส", "หจก.มือถือชุมชน 2009", "พิมลวรรณ ขนมไทย", "ห้างทองศรีสุวรรณ", "ทอฝัน เครื่องนอน", "ห้างทองสุพัตรา", "อุปกรณ์ประดับยนต์", "คิวท์ตี้พริ้นเซส", "ขนม นม เนย", "บ้านยา", "Lotus Spa", "T Diamond Optic", "ด๊อกเตอร์ดรัก", "PN Mobile", "อโรม่าออฟเค้ก", "เบิร์ดโฟน", "PiJiTTRA", "CK Game", "แต้ว โมบาย", "โชคอนันต์", "Cream", "OK TELECOM", "Juicy Bing", "พารวยโฟน", "KTKเทเลโฟน", "CC Mobile", "Feel Good (วาฟเฟิล)", "A Phone", "หนุ่มซ่อมด่วน", "PN Phone", "เฌอเต ซูชิ", "เฌอโฟน", "จ๊ะจ๊า โมบาย", "พารากอน เกมส์", "แอ๊วโมบาย", "นำชัย", "Hybrid Cloud/ไฮบริด คลาวด์", "So Good Shop", "เอลิซ สตูดิโอ", "ไจแอ้นท์ลูกชิ้นปลาระเบิด", "ไผ่ทองสเตชั่น", "วิชั่น บีริช", "ฮาลาล ทะเลดอง", "BB Home Toy", "หจก. สี่แยกไอทีกรุ๊ป สาขาโลตัสคลองท่อม", "ห้างทองหยงเตียน", "คิวตี้ปริ้นเซส", "ธราดลการแว่น", "Coffman Coffee", "POP CAR SPA", "เวสปอยท์", "ห้างทองหวังโต๊ะกังเยาวราช", "Small World", "นิกกี้ไอศกรีม", "BIRD PHONE", "SMART MOBILE", "T.S.Mobile Center", "แม่กิมมือถือ", "มาเรียมของฝาก", "สนามชัยบิวตี้", "iUNiX Studio", "Nijyu Shop", "ธราดล การแว่น", "เบียร์โมบาย", "AT Phone2", "DDM Phone", "MC Jean", "PK TOYS", "อายออพติค", "CJ Phone", "K.H.Phone", "เกมส์ซน", "ธนากร เทเลคอม", "ปันโตะบิวตี้", "Winner", "โตเต้ โมบาย", "นงลักษณ์มขนมไทยของฝาก", "ร้านบ้านเกมส์", "ธนวิชญ์โฟน", "The posh toy", "เค้กทองใบ", "จ.เจริญ", "อ้อม อ้อม โมบาย", "Green Smile Shop", "SSG Shop", "ลาวาพิซซ่า", "เฮงดีโมบาย", "@ CAR WASH", "เค้กคุณญ่า", "อามโมบาย", "Party Shop", "อิ๊คคิวโมบาย", "Kiddy Ride", "เมธีร์ เทเลคอม", "แว่นสตาร์ทอาย", "PB Mobile", "ทาโกยากิ", "หลานยาย IT", "Drug Square", "Got Crape & Pizza Halal", "GREATBARBERSHOP", "Moma's Tea", "My Way Coffee", "คงทน ออฟติค", "Ing kid shop", "3D-โมบาย", "YO-YO", "A&B Telephone", "พรรุ่งเรืองขนมของฝาก", "บีแอลโฟน", "หอมมนต์ เบเกอรี่", "Pijika อุปกรณ์มือถือ", "Coffee zone", "Barber Near Me", "รุ่งเรือง เภสัช", "289 สมาร์ทโฟน", "Autoclick", "Buddy Phone", "C&B BAKERY", "Diamond Optic", "Richy", "ไบค์แมน", "ก๋วยเตี๋ยวเป็ดเฮียแก้ว", "ห้างทองหวังทองดี", "Gumball", "ชาไข่มุก TCHAYA", "หรรษาติมซ่า", "ห้างทองหวังอยากมี", "นัทโฟนช็อป", "เหมียวโฟน", "ฟาร์มเคส", "CHAKAMU", "Chick Daebak", "มิสซูชิไข่หวานคาเฟ่", "YumBoX", "Monny Beauty", "เจ้าโมบาย", "Rak Eye Optic", "S.R Plastic", "Sugar2", "ร้านนะโมช้อป", "Studio Mobile", "ห้างทองอยากมีตังค์", "เคท มั่งมี", "ของอร่อยเยาวราช", "GK Mobile", "M Toy", "ถูกใจไอที", "Bi-Cha", "COFFEE HOUSE BY TAE", "Jinne&Nail", "แซ่บตากแอร์", "กรีนพิซซ่า", "3P LAND", "Kids Land", "T-Pharma", "Wash&Go", "Momo tea", "หวานฉ่ำ", "KIN", "SUBWAY", "Swensens", "KUB", "Meat Things", "Colla Tea & Crep", "Tooni Tako", "Cute Pig Korean BBQ", "MINI BEAR", "The 1983 Nail&Spa", "U & ME", "มูมมามสุกี้", "Tora Cha", "บ้านชา & โรตี", "แลขวัญ คิทเช่น", "กับข้าว ข้าวหอม", "ดาณู ขนมจีนน้ำยาปูฮาลาล", "ตำอุดร", "Chictage", "เก๋ Kea's Shop", "น้ำกิ๊ฟช็อป", "พริตตี้ ซาลอน", "ยูนิค นวดเพื่อสุขภาพ", "B Infinity Nail colors", "Namaste Pilates", "Next24Studio", "Salon SBY", "Super Drug", "Valhalla MMA Gym", "Bombay Delite Indian", "ห้างทองอรสา 5", "Oka Shabu", "Owndays", "Ozawa Ramen X Karaage Kyoudai", "กะเพราแท้", "ซาลาเปามาดามลี", "ตำสุรินทร์", "ABC Cooking", "ห้างทองอลงกรณ์", "Haru. Coffeehouse", "KOI The'", "LE CELLO", "Yunomori Spa", "ภูมิใจไทย", "ห้างทองอึ้งเฮงหลี", "ครัวปีระกา", "Queens Bakery", "กาแฟไทยเดิม", "Japs by เรือขุดแร่", "MSIT", "ห้างทองอุดร-สกล", "อรวรรณ จิวเวอร์รี่", "NaNa Beauty Mart", "EVE AND BOY", "คลังยา", "นั่งปิ้งชาบู", "ข้าวมันไก่ศรีทอง", "ไพลิน", "Protime"];

const lotusMallShopsBrandDay = {
    "Pizza Hut": [
        "2025-08-03",
        "2025-08-09",
        "2025-08-20",
        "2025-08-30",
        "2025-09-05",
        "2025-09-16",
        "2025-09-22",
        "2025-09-28",
        "2025-10-04",
        "2025-10-10",
        "2025-10-16",
        "2025-09-21",
        "2025-09-27"
    ],
    "Mc Jeans": [
        "2025-08-05",
        "2025-08-28",
        "2025-09-13"
    ],
    "MR. D.I.Y.": [
        "2025-08-18",
        "2025-09-07"
    ],
    "Dairy Queen": [
        "2025-08-07",
        "2025-09-02",
        "2025-10-23",
        "2025-10-29"
    ],
    "Dunkin'": [
        "2025-08-22",
        "2025-09-09"
    ],
    "Swensens": [
        "2025-08-11",
        "2025-09-24",
        "2025-10-26"
    ],
    "S&P": [
        "2025-08-24",
        "2025-09-18",
        "2025-10-05",
        "2025-10-28"
    ],
    "KFC": [
        "2025-08-13",
        "2025-10-14",
        "2025-10-22",
        "2025-10-30"
    ],
    "Major Cineplex": [
        "2025-08-01",
        "2025-08-26",
        "2025-09-20",
        "2025-10-07",
        "2025-10-24"
    ],
    "The Pizza Company": [
        "2025-08-02",
        "2025-08-16",
        "2025-09-26",
        "2025-10-12",
        "2025-10-25"
    ]
}

function DoublePointShops({ lotusMallShopsBrandDay }) {
  const today = moment().format('YYYY-MM-DD');

  // compute once per render
  const shopsToday = Object
      .entries(lotusMallShopsBrandDay)
      .filter(([, dates]) => dates.includes(today))
      .map(([shopName]) => shopName);

  if (shopsToday.length === 0) {
    return <div style={{ marginTop: '20px'}}><h5>No Brand Day shops today.</h5></div>;
  }

  return (
    <div style={{ marginTop: '20px'}}>
      <h5 style={{ color: "#4CAF50"}}>🎉 Brand Day shops:</h5>
      <ul style={{ margin: 0, paddingLeft: 20 }}>
        {shopsToday.map(shop => (
          <li key={shop}><strong>{shop}</strong></li>
        ))}
      </ul>
    </div>
  );
}

// 2. ฟังก์ชันช่วยคำนวณ warning แต่ละบิล
// function calculateWarnings(receiptList = []) {
//   // เตรียมเซ็ตชื่อร้าน
//   const specialSet = new Set(specialShopList);
//   const lotusSet   = new Set(
//     lotusMallShops.filter(s => !specialSet.has(s))
//   );

//   // state ติดตามสิทธิ์
//   let specialUsed = false;            // เคยจ่าย 20 ดวง ไปแล้วหรือยัง
//   let lotusDistinctCount = 0;         // ร้านในโลตัสใหม่กี่ร้าน
//   const lotusPerShopCount = {};       // { shopName: count }

//   return receiptList.map(item => {
//     const shop  = item.shop;
//     const price = Number(item.priceSum) || 0;
//     let warn = '';

//     if (specialSet.has(shop)) {
//       // ร้านทอง/แว่น
//       if (price < 10000) {
//         warn = 'ยอดซื้อไม่ถึง 10,000 บาท';
//       } else if (!specialUsed) {
//         specialUsed = true;  // ให้สิทธิ์บิลแรกผ่าน
//       } else {
//         warn = 'รับแสตมป์จากกลุ่มร้านทอง/แว่นได้เพียง 1 ใบต่อวัน';
//       }

//     } else if (lotusSet.has(shop)) {
//       // โลตัสมอลล์
//       if (price < 100) {
//         warn = 'ยอดซื้อไม่ถึง 100 บาท';
//       } else {
//         const used = lotusPerShopCount[shop] || 0;
//         if (used >= 1) {
//           warn = 'รับได้จากร้านเดิมครั้งเดียวต่อวัน';
//         } else if (lotusDistinctCount >= 2) {
//           warn = 'รับสแตมป์จากร้านในโลตัสมอลล์ได้สูงสุด 2 ใบต่อวัน';
//         } else {
//           // ให้สิทธิ์บิลนี้
//           lotusPerShopCount[shop] = 1;
//           lotusDistinctCount += 1;
//         }
//       }

//     } else {
//       // ร้านอื่นๆ
//       warn = 'ร้านนี้ไม่ร่วมรายการสะสมแสตมป์';
//     }

//     return warn;
//   });
// }

function calculateSummaryWarnings(receiptList = []) {
 // 0) กรองบิลที่มี code เท่านั้น (ข้าม code === null)
  const validReceipts = receiptList.filter(r => r.code != null && r.remark != 'REJECT' && r.remark != 'PENDING');

  const specialSet = new Set(specialShopList);
  const lotusSet   = new Set(lotusMallShops.filter(s => !specialSet.has(s)));

  // แยกกลุ่มบิล
  const specialReceipts = validReceipts.filter(r => specialSet.has(r.shop));
  const lotusReceipts   = validReceipts.filter(r => lotusSet.has(r.shop));

  // 1) Quota 22 ดวง
  const totalPoints = validReceipts.reduce(
    (sum, r) => sum + (Number(r.point) || 0),
    0
  );

  // 2) ร้านทอง/แว่น > 1 ใบ
  const specialCount = specialReceipts.length;

  // 3) ร้านในโลตัสมอลล์ ซ้ำหรือเกิน 2 ร้าน
  const shopCounts = lotusReceipts.reduce((acc, r) => {
    acc[r.shop] = (acc[r.shop] || 0) + 1;
    return acc;
  }, {});
  const distinctLotusShops = Object.keys(shopCounts);
  const hasDuplicateLotus = distinctLotusShops.some(
    shop => shopCounts[shop] > 1
  );
  const tooManyLotusShops = distinctLotusShops.length > 2;

  const warnings = [];
  if (totalPoints >= 22) {
    warnings.push('จำนวนแสตมป์ครบ Quota 22 ดวง/วัน');
  }
  if (specialCount > 1) {
    warnings.push('จำนวนร้านทองและร้านแว่นมากว่า 1 ใบ');
  }
  if (hasDuplicateLotus || tooManyLotusShops) {
    warnings.push('จำนวนร้านค้าซ้ำกันหรือเกิน 2 ร้าน');
  }

  return warnings;
}

class EarnReportFormAura extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            remark: false,
            first: true,
            discount: null,
            pointCal: null
        };
    }

    componentDidUpdate(prevProps) {
        const prevId = lodash.get(prevProps.initialValues, '_id');
        const curId  = lodash.get(this.props.initialValues, '_id');
        const opened = !prevProps.formOpen && this.props.formOpen;

        if (opened || prevId !== curId) {
            this.setState({
                first: true,
                remark: this.props.initialValues?.remark === 'REJECT', // โหมดโชว์เหตุผลเฉพาะถ้าเดิมเป็น REJECT
                discount: null,
                pointCal: null
            });
            // เคลียร์เหตุผลเก่าใน redux-form
            this.props.dispatch(change(FORM_NAME, 'reject_note', undefined));
        }
    }

    closeDialog() {
        const { dispatch } = this.props;
        this.setState({
            discount: null,
            pointCal: null
        })
        dispatch({ type: 'CLOSE_EARN_REPORT_EDIT' });
    }


    handleSubmit(values) {
        const { dispatch, user, initialValues,earnReport} = this.props;

        if (initialValues.remark !== values.remark||initialValues.code!==values.code) {
          if (values.remark=="PENDING") {
            const remark = values.remark;
            const transactionId = values._id;
            const code = values.code;
            const type = values.type
            let params = {
              remark,
              transactionId,
              code,
              type
            };
            
            dispatch(reportActions.updateTransaction(params));
          }else{
            const remark = values.remark;
            const transactionId = values._id;
            const reject_note = values.reject_note;
            const productId = values.productId;
            const code = values.code
            const type = values.type
            let receiptDate = "";
            if (values.receiptDate) {
              receiptDate = plugins.datetimeFormat(
                values.receiptDate,
                "mongo"
              );
            } else {
              receiptDate = "";
            }
            let params = {};
            if (values.remark=="SUCCESS") {

              let point = this.state.pointCal ? parseFloat(this.state.pointCal) : lodash.get(this.props.initialValues, 'point');
              let discount = this.state.discount ? parseFloat(this.state.discount) : 0;

              params = {
                remark,
                transactionId,
                reject_note,
                point,
                receiptDate,
                discount,
                code,
                type
              };
            } else {
              params = {
                remark,
                transactionId,
                reject_note,
                code,
                type
              };
            }

            this.setState({
                discount: null,
                pointCal: null
            })

            dispatch(reportActions.updateTransaction(params))  
          }
          
          /*  this.setState({ remark: false, first: true, approved_vitamilk: false }) */
        } else if (
          values.remark == "REJECT" &&
          initialValues.reject_note !== values.reject_note
        ) {
          const remark = values.remark;
          const transactionId = values._id;
          const reject_note = values.reject_note;
          const code = values.code;
          let params = {
            remark,
            transactionId,
            reject_note,
            code
          };

          this.setState({
            discount: null,
            pointCal: null
          })
          dispatch(reportActions.updateTransaction(params));
        } else {
          this.closeDialog();
        }
        // console.log(pointCal, lodash.get(this.props.initialValues, 'point'), this.state.discount);

        // this.setState({ remark: false, first: true })
        // const { dispatch, user, initialValues } = this.props;
        // if (initialValues.remark !== values.remark) {
        //     const remark = values.remark
        //     const transactionId = values._id
        //     const reject_note = values.reject_note
        //     let date_now_check = new Date();
            
        //     let year_check = date_now_check.toLocaleString("en-US", {
        //       year: "numeric",
        //     });
        //     let month_check = date_now_check.toLocaleString("th", {
        //       month: "2-digit",
        //     });
        //     let Day_check = date_now_check.toLocaleString("th", {
        //       day: "2-digit",
        //     });
        //     let hour_check = date_now_check.toLocaleString("th", { hour: "2-digit" });
        //     let minute_check = date_now_check.toLocaleString("th", {
        //       minute: "2-digit",
        //     });
        //     month_check = month_check.padStart(2, "0");
        //     Day_check = Day_check.padStart(2, "0");
        //     hour_check = hour_check.padStart(2, "0");
        //     minute_check = minute_check.padStart(2, "0");
        
        //     let fulldatecheck =
        //       year_check + month_check + Day_check ;
        //     let fulldateNum = Number(fulldatecheck);


        //     const start = 20230701
        //     let set_campaign='summer'
            
        //     if (fulldateNum>=Number(start)) {
        //         set_campaign="rainy"
        //     } 

        //     let params = {
        //         remark,
        //         transactionId,
        //         reject_note,
        
        //     }
        //     params.type_campaign=set_campaign
        //     dispatch(reportActions.updateTransaction(params))
        // } else if (values.remark == 'REJECT' && initialValues.reject_note !== values.reject_note) {
        //     const remark = values.remark
        //     const transactionId = values._id
        //     const reject_note = values.reject_note
        //     let params = {
        //         remark,
        //         transactionId,
        //         reject_note,
                
        //     }
        //     dispatch(reportActions.updateTransaction(params))
        // } else {
        //     this.closeDialog()
        // }
    }

    render() {
        const { handleSubmit, formOpen, fromMode, classes, earnReport, tableKey, initialValues, handleChange } = this.props;

        const id = lodash.get(initialValues, '_id')
        const user = lodash.get(initialValues, 'user')
        const userFirstName = lodash.get(user, 'firstName')
        const userLastName = lodash.get(user, 'lastName')
        const userPhoneNumber = lodash.get(user, 'phoneNumber')
        const sn_remark = lodash.get(initialValues, 'sn_remark')
        const sn_verified = lodash.get(initialValues, 'sn_verified')
        const date = lodash.get(initialValues, 'date')
        const model = lodash.get(initialValues, 'model')
        const code = lodash.get(initialValues, 'code')
        const check_id = lodash.get(initialValues, 'check_id')
        const store_name = lodash.get(initialValues, 'store_name')
        const machine_number = lodash.get(initialValues, 'machine_number')
        const price = lodash.get(initialValues, 'price')
        const images = lodash.get(initialValues, 'images')
        const images_sn = lodash.get(initialValues, 'images_sn')
        const images1 = lodash.get(initialValues, 'images1')
        const images2 = lodash.get(initialValues, 'images2')
        const remark = lodash.get(initialValues, 'remark')
        const inputList = lodash.get(initialValues, 'inputList')
        const province = lodash.get(initialValues, 'province')
        const point = lodash.get(initialValues, 'point')
        const shop = lodash.get(initialValues, 'shop')
        const priceSum = lodash.get(initialValues, 'priceSum')
        const discount = lodash.get(initialValues, 'discount')
        const receiptNumber = lodash.get(initialValues, 'receiptNumber')
        const checkDuplicate = lodash.get(initialValues, 'checkDuplicate')
        const receiptList = lodash.get(initialValues, 'receiptList')
        const type = lodash.get(initialValues, 'type')
        let receiptDate = lodash.get(initialValues, 'receiptDate')
        // Convert UTC date to Thai timezone and Buddhist Era format
        if (receiptDate) {
            // Parse UTC date and convert to Thai timezone (GMT+7)
            const utcDate = new Date(receiptDate)
            const thaiOffset = 7 * 60 // Thailand is GMT+7
            const thaiDate = new Date(utcDate.getTime() + thaiOffset * 60 * 1000)

            const day = String(thaiDate.getUTCDate()).padStart(2, '0')
            const month = String(thaiDate.getUTCMonth() + 1).padStart(2, '0')
            const yearBE = thaiDate.getUTCFullYear() + 543

            receiptDate = `${day}/${month}/${yearBE}`
        }
        const shippingAddress = lodash.get(initialValues, 'shippingAddress')
        
        let check_reject_note = false
        if (remark === 'REJECT') {
            check_reject_note = true
        }
        let remarkOptions
        if (remark === 'PENDING') {
            remarkOptions = [
                {
                    label: 'Pending',
                    value: 'PENDING'
                },
                {
                    label: 'Approve',
                    value: 'SUCCESS'
                },
                {
                    label: 'Reject',
                    value: 'REJECT'
                }
            ]
        } else {
            remarkOptions = [
                {
                    label: 'Approve',
                    value: 'SUCCESS'
                },
                {
                    label: 'Reject',
                    value: 'REJECT'
                }
            ]
        }

        if (sn_remark === 'CODE_NOT_FOUND' || sn_remark === 'CODE_WAS_USED') {
            remarkOptions = [
                {
                    label: 'Pending',
                    value: 'PENDING'
                },
                {
                    label: 'Reject',
                    value: 'REJECT'
                }
            ]
        }

        let imageList = []
        let imageListSn = []
        let imageList1 = []
        let imageList2 = []


        lodash.forEach(images_sn, function (value, key) {
            imageListSn.push(value.url);
        });

        const showImagesSn = imageListSn.map((item) =>
            <a href={item} target="_blank">
                <div style={{ width: '210px', height: '210px', float: 'left' }}>
                    <img src={item} style={imgStyle} />
                </div>
            </a>
        );

        lodash.forEach(images, function (value, key) {
            imageList.push(value.url);
        });
        const showImages = imageList.map((item) =>
            <a href={item} target="_blank">
                <div style={{ width: '210px', height: '210px', diplay: 'inline-block' }}>
                    <img src={item} style={imgStyle} />
                </div>
            </a>
        );


        lodash.forEach(images1, function (value, key) {
            imageList1.push(value.url);
        });
        const showImages1 = imageList1.map((item) =>
            <img src={item} width="300" />
        );


        lodash.forEach(images2, function (value, key) {
            imageList2.push(value.url);
        });
        const showImages2 = imageList2.map((item) =>
            <img src={item} width="300" />
        );

        let columns = [
            { name: "skuId", label: "SKU ID" },
            { name: "skuName", label: "SKU NAME" },
            { name: "quantity", label: "Quantity" },
        ]

        let options = {
            serverSide: false,
            count: false,
            page: false,
            rowsPerPage: 100,
            selectableRows: "none",
            print: false,
            download: false,
            filter: false,
            responsive: "scroll",
            rowsPerPageOptions: false,
            search: false,
            pagination: false,
            sort: false,
            sortFilterList: false,
            viewColumns: false,
        }
        const list = Array.isArray(receiptList) ? receiptList : [];
        // const warnings = calculateWarnings(list);
        const summaryWarnings = calculateSummaryWarnings(list);
        
        if (Array.isArray(summaryWarnings) && summaryWarnings.length > 0) {
            remarkOptions = [
                {
                    label: 'Pending',
                    value: 'PENDING'
                },
                {
                    label: 'Reject',
                    value: 'REJECT'
                }
            ]
        }

        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={formOpen}
                keepMounted
                aria-labelledby="modal-slide-title"
                aria-describedby="modal-slide-description"
                maxWidth='lg'
                scroll="body"
                disableRestoreFocus={true}
            >
                {imageList.length != 0 && (<DialogContent
                    id="import-result-detail-dialog"
                    // className={classes.modalBody}
                    style={{ padding: "100", textAlign: 'left' }}
                >
                    <h4 className={classes.modalTitle} style={{ textAlign: 'left' }}>
                        <b>Transaction</b>
                    </h4>

                    <GridContainer spacing={4}>
                        <GridItem xs={12}>
                            <h5><b>ใบกำกับภาษี</b> </h5>
                            <div style={{
                                display: 'flex',         // ใช้ flexbox
                                flexDirection: 'row',    // แนวนอน
                                flexWrap: 'wrap',        // ถ้ามากกว่า 1 แถว ให้ขึ้นบรรทัดใหม่
                                gap: '10px'              // ระยะห่างระหว่างรูป
                            }}>{showImages}</div>
                        </GridItem>
                        {/* <GridItem xs={8}>
                            <h5><b>Serial number</b></h5>
                            <div>{showImagesSn}</div>
                        </GridItem> */}
                    </GridContainer>
                    <br />
                    <GridContainer spacing={1}>
                        <GridItem xs={4}>

                            {model && <div><h5><b>Model</b></h5>
                                <div style={{display: 'inline-flex'}}>
                                    <div style={{float: 'left'}}>{model}</div> 
                                    <CheckCircle style={{ marginLeft: '5px', color: '#79BF00'}}/>
                                </div>
                            </div>
                            }

                            {(typeof checkDuplicate !== 'undefined' && checkDuplicate.length != 0) ?
                                <h5 style={{ color: '#f44336'}}><b>เลขที่ใบเสร็จ/ใบกำกับภาษี <CancelIcon style={{ position: 'absolute', marginLeft: "7px"}}></CancelIcon></b></h5> :
                                <h5><b>เลขที่ใบเสร็จ/ใบกำกับภาษี</b></h5>
                            }
                            
                            <div>{typeof receiptNumber !== 'undefined' ? receiptNumber : "-"}</div>

                            <h5><b>Serial number</b></h5>
                            {sn_verified !== undefined ?
                            <div style={{display: 'inline-flex'}}>
                                <div style={{float: 'left'}}>{code}</div>
                                {sn_verified ? <CheckCircle style={{ marginLeft: '5px', color: '#79BF00'}}/> : <Cancel style={{ marginLeft: '5px', color: '#dc3545'}}/>}
                                <div style={{ marginLeft: '5px' }}>{sn_remark === "CODE_NOT_FOUND" ? "(รหัสผิด)" 
                                : sn_remark === "CODE_WAS_USED" ? "(รหัสซ้ำ)" 
                                : null}</div>
                            </div>
                            : <div style={{display: 'inline-flex'}}><div style={{float: 'left'}}>{code}</div></div>}

                            <h5><b>วันที่ในใบเสร็จ</b></h5>
                            <div>{receiptDate}</div>
                            { 
                                shippingAddress && shippingAddress?.addressLine1 && (
                                <div>
                                    <h5><b>Shipping Address</b></h5>
                                    <div style={{paddingLeft: '10px'}}>
                                        <b>ที่อยู่ (Address) : </b>{shippingAddress.addressLine1} <br/>
                                        <b>ตำบล (Subdistrict)  : </b>{shippingAddress.subDistrict}<br/>
                                        <b>อำเภอ (District) : </b>{shippingAddress.district}<br/>
                                        <b>จังหวัด (Province) : </b>{shippingAddress.province}<br/>
                                        <b>รหัสไปรษณีย์ (Postal code) : </b>{shippingAddress.zipcode} <br/>
                                    </div>
                                </div>
                                )
                            }
                            <h5><b>Province</b></h5>
                            <div>{province !== null && province !== "" ? province : "-"}</div>

                            <h5><b>Shop</b></h5>
                            <div>{shop}</div>
                            { type === 'receipt-point' &&
                                <>
                                    <hr />
                                    <h5><b>ยอดซื้อสินค้า (บาท)</b></h5>
                                    <div>{Number(priceSum).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0}</div>

                                    <h5><b>Point ที่จะได้รับ</b></h5>
                                    <div>{point}</div>
                                    <hr />
                                </>
                            }
                            
                            { type == 'lucky-draw' &&
                            <>
                                <h5><b>ยอดซื้อสินค้า (บาท)</b></h5>
                                <div>{Number(priceSum).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0}</div>
                            </>
                            }
                            </GridItem>


                            { (typeof checkDuplicate !== 'undefined' && checkDuplicate.length != 0) ?  
                                (<GridItem xs={8}>
                                    <h5><b>เลขที่ใบเสร็จ/ใบกำกับภาษี ซ้ำ</b></h5>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Serial number</TableCell>
                                                <TableCell>Status</TableCell>
                                                {/* <TableCell>Shop</TableCell>
                                                <TableCell>Province</TableCell>
                                                <TableCell>Image</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {checkDuplicate.map((item) =>
                                                <TableRow>
                                                    <TableCell>{item.code}</TableCell>
                                                    <TableCell>
                                                        {
                                                            item.remark === "SUCCESS" ? <b style={{ marginLeft: '5px', color: '#79BF00'}}>{item.remark}</b>
                                                            : item.remark === "REJECT" ? <b style={{ marginLeft: '5px', color: '#f44336'}}>{item.remark}</b>
                                                            : <b>{item.remark}</b>
                                                        }
                                                    </TableCell>
                                                    {/* <TableCell>{item.shop}</TableCell>
                                                    <TableCell>{item.province}</TableCell>
                                                    <TableCell>
                                                        <a href={item.images[0].url} target="_blank">
                                                            <div style={{ width: '210px', height: '210px', float: 'left' }}>
                                                                <img src={item.images[0].url} style={imgStyle} />
                                                            </div>
                                                        </a>
                                                    </TableCell> */}
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </GridItem>) : ""
                            }

                            {/* lotus happy stamp has receiptList */}
                            {Array.isArray(receiptList) && receiptList.length > 0 && (
                                <GridItem xs={8}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Receipt Number</TableCell>
                                            {/* <TableCell>Serial number</TableCell> */}
                                            <TableCell>Receipt Date</TableCell>
                                            <TableCell>Branch</TableCell>
                                            <TableCell>Shop</TableCell>
                                            {/* <TableCell>Province</TableCell> */}
                                            <TableCell>Price</TableCell>
                                            <TableCell>Point</TableCell>
                                            <TableCell>Status</TableCell>
                                            {/* <TableCell>Warning</TableCell> */} {/* เพิ่มคอลัมน์เตือน */}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {receiptList.map((item, idx) => (
                                        <TableRow key={item.code}>
                                            <TableCell style={item._id == id ? { fontWeight: 'bold' }: {}}>{item.receiptNumber}</TableCell>
                                            {/* <TableCell>{item.code}</TableCell> */}
                                            <TableCell>{item.receiptDate && formatTxnDate(item.receiptDate)}</TableCell>
                                            <TableCell>{item.branch}</TableCell>
                                            <TableCell>{item.shop}</TableCell>
                                            {/* <TableCell>{item.province}</TableCell> */}
                                            <TableCell>{item.priceSum}</TableCell>
                                            <TableCell>{item.point}</TableCell>
                                            <TableCell>
                                                {item.remark === 'SUCCESS' ? (
                                                <b style={{ color: '#79BF00' }}>{item.remark}</b>
                                                ) : item.remark === 'REJECT' ? (
                                                <b style={{ color: '#f44336' }}>{item.remark}</b>
                                                ) : (
                                                <b>{item.remark}</b>
                                                )}
                                            </TableCell>
                                            {/* <TableCell>
                                                {warnings[idx] && (
                                                <Typography variant="body2" color="error">
                                                    {warnings[idx]}
                                                </Typography>
                                                )}
                                            </TableCell> */}
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                                <DoublePointShops lotusMallShopsBrandDay={lotusMallShopsBrandDay} />
                                <hr />
                                {summaryWarnings.length > 0 && (
                                    <div style={{ color: 'red', marginBottom: 16 }}>
                                        <h5>Warning</h5>
                                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                                            {summaryWarnings.map(msg => (
                                            <li key={msg}>{msg}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                </GridItem>
                            )}
                    </GridContainer>
                </DialogContent>)}

                {(imageList1.length != 0 && imageList2.length != 0) && (<DialogContent
                    id="import-result-detail-dialog"
                    // className={classes.modalBody}
                    style={{ padding: "100", textAlign: 'left' }}
                >
                    <h4 className={classes.modalTitle} style={{ textAlign: 'left' }}>
                        <b>Transaction</b>
                    </h4>

                    <h5><b>Installation</b></h5>
                    <div>{showImages1}</div>

                    <h5><b>Location</b></h5>
                    <div>{showImages2}</div>


                </DialogContent>)}


                <form name={FORM_NAME} onSubmit={handleSubmit(this.handleSubmit.bind(this))}
                >
                    <DialogContent
                        id="earn-report-form-dialog"
                        className={classes.modalBody}
                    >

                      <GridContainer spacing={2}>
                        <GridItem xs={4}>
                          <h5>
                            <b>สินค้า</b>
                          </h5>
                          {inputList &&
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>ขนาด</TableCell>
                                  <TableCell>จำนวน</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {inputList.map((item) =>
                                  <TableRow>
                                    <TableCell>{item.itemSize}</TableCell>
                                    <TableCell>{item.itemCount}</TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          }
                        </GridItem>
                        <GridItem xs={6}>
                          {inputList &&
                            <>
                              <h5><b>ราคารวม</b></h5>
                              <div>
                                <Field
                                  name="priceSum"
                                  component={CustomInput}
                                  type="text"
                                  labelText={"ราคารวม"}
                                  formControlProps={{
                                      fullWidth: true
                                  }}
                                  value={priceSum}
                                  disabled={true}
                                />
                              </div>
                              
                              <h5><b>ส่วนลด</b></h5>
                              <div>
                                {/* <input type="number"
                                className="MuiInputBase-input"
                                max={point}
                                value={this.state.discount !== null  ? this.state.discount : discount}
                                onChange={(e) => {
                                    let val = e.target.value ? e.target.value : 0
                                    let cal = parseFloat(point) - parseFloat(val);
                                    if (cal < 0) {
                                      cal = 0
                                    }

                                    // discount = e.target.value
                                    
                                    this.setState({
                                      discount: e.target.value,
                                      pointCal: cal
                                    })
                                  }}
                                  readOnly={(remark === 'REJECT' || remark === 'SUCCESS' ) ? true : false}
                                /> */}
                                <Field
                                    name="discount"
                                    component={CustomInput}
                                    type="number"
                                    labelText={"ส่วนลด"}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    // value={this.state.discount}
                                    max={point}
                                    className="MuiInputBase-input"
                                    value={this.state.discount !== null ? this.state.discount : discount}
                                    onChange={(e) => {
                                        let val = e.target.value ? e.target.value : 0
                                        let cal = parseFloat(point) - parseFloat(val);
                                        if (cal < 0) {
                                        cal = 0
                                        }
                                        
                                        this.setState({
                                        discount: e.target.value,
                                        pointCal: cal
                                        })
                                    }}
                                    disabled={(remark === 'REJECT' || remark === 'SUCCESS' ) ? true : false}
                                />
                              </div>

                              <h5><b>คะแนน</b></h5>
                              <div>
                                {/* pointAndDiscount() */}
                                {/* <input type="text"
                                name="pointCal"
                                value={this.state.pointCal !== null ? this.state.pointCal : point}
                                readOnly /> */}
                                <Field
                                    name="pointCal"
                                    component={CustomInput}
                                    type="text"
                                    labelText={this.state.pointCal !== null ? this.state.pointCal : point}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    value={this.state.pointCal !== null ? this.state.pointCal : point}
                                    onChange={(e) => {
                                        let val = e.target.value ? e.target.value : 0
                                        let cal = parseFloat(val);
                                        if (cal < 0) {
                                            cal = 0
                                        }
                                        
                                        this.setState({
                                            pointCal: parseFloat(val)
                                        })
                                    }}
                                    // disabled={true}
                                />
                              </div>
                            </>
                          }
                        </GridItem>
                      </GridContainer>
                      
                      <GridContainer>
                          <GridItem xs={6} sm={4} md={4}>
                              <Field
                                  name="remark"
                                  component={CustomSelect}
                                  type="text"
                                  labelText="Status"
                                  formControlProps={{
                                      fullWidth: true
                                  }}
                                  disabled={(imageList.length != 0 && remark === 'SUCCESS' ) ? true : false}
                                  optionsList={remarkOptions}
                                  onChange={(e) => {
                                      this.setState({
                                          remark: e.target.value === 'REJECT' ? true : false,
                                          first: false
                                      })
                                  }}
                              />
                          </GridItem>
                      </GridContainer>{console.log(this.state.first, check_reject_note)}
                        {/* lotus happy stamp has receiptList */}
                        {/* Improvement
                            const hasReceipts = Array.isArray(receiptList) && receiptList.length > 0;
                            const isInitialReject = this.state.first && check_reject_note;   // remark เดิมเป็น REJECT
                            const isCurrentReject = !this.state.first && this.state.remark;  // ผู้ใช้เลือก REJECT ตอนนี้

                            const shouldShowReasons = hasReceipts && (isInitialReject || isCurrentReject);

                            { shouldShowReasons ? ( ...แสดงรายการเหตุผล... ) : null }
                        */}
                        {/* <div style={{ fontFamily: 'monospace', background: '#f7f7f7', padding: 6, border: '1px dashed #ccc' }}>
                            first: {String(this.state.first)} | check_reject_note: {String(check_reject_note)} | state.remark: {String(this.state.remark)}
                        </div> */}
                        {Array.isArray(receiptList) && receiptList.length && ((this.state.first && check_reject_note) || (!this.state.first && this.state.remark)) ? (
                            <GridContainer>
                                <GridItem xs={6} sm={5} md={5}>
                                    <Field
                                        name="reject_note"
                                        component={CustomRadio}
                                        radioLists={[
                                            {
                                                value: "รูปภาพไม่ชัดเจน/ไม่ครบถ้วน",
                                                label: <span style={{ fontWeight: '300' }}>รูปภาพไม่ชัดเจน/ไม่ครบถ้วน</span>,
                                            },
                                            {
                                                value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                                                label: <span style={{ fontWeight: '300' }}>ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน</span>,
                                            },
                                            {
                                                value: "วันที่ในใบเสร็จไม่อยู่ในระยะเวลากิจกรรม",
                                                label: <span style={{ fontWeight: '300' }}>วันที่ในใบเสร็จไม่อยู่ในระยะเวลากิจกรรม</span>,
                                            }, 
                                            {
                                                value: "ใบเสร็จที่แนบมาไม่ได้ออกโดยร้านค้าในโลตัส",
                                                label: <span style={{ fontWeight: '300' }}>ใบเสร็จที่แนบมาไม่ได้ออกโดยร้านค้าในโลตัส</span>,
                                            },
                                            {
                                                value: "ใบเสร็จร้านค้าต้องเป็นใบเสร็จพิมพ์จากเครื่องพิมพ์เท่านั้น",
                                                label: <span style={{ fontWeight: '300' }}>ใบเสร็จร้านค้าต้องเป็นใบเสร็จพิมพ์จากเครื่องพิมพ์เท่านั้น</span>,
                                            },
                                            {
                                                value: "ใบเสร็จอยู่ในกลุ่มสินค้า/ร้านค้าที่ไม่ร่วมรายการ",
                                                label: <span style={{ fontWeight: '300' }}>ใบเสร็จอยู่ในกลุ่มสินค้า/ร้านค้าที่ไม่ร่วมรายการ</span>,
                                            },
                                            {
                                                value: "ลงทะเบียนซ้ำ",
                                                label: <span style={{ fontWeight: '300' }}>ลงทะเบียนซ้ำ</span>,
                                            },
                                            {
                                                value: "วันนี้ได้รับแสตมป์ครบตามโควต้าที่กำหนดแล้ว",
                                                label: <span style={{ fontWeight: '300' }}>วันนี้ได้รับแสตมป์ครบตามโควต้าที่กำหนดแล้ว</span>,
                                            },
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                        ) : (
                            <>
                                {(imageList.length != 0 && this.state.first && check_reject_note) && (
                                    <GridContainer>
                                        <GridItem xs={6} sm={5} md={5}>
                                            <Field
                                                name="reject_note"
                                                component={CustomRadio}
                                                radioLists={[
                                                    {
                                                        value: "ข้อมูลในใบเสร็จไม่ครบถ้วนตามเงื่อนไขโปรโมชั่น",
                                                        label: <span style={{ fontWeight: '300' }}>ข้อมูลในใบเสร็จไม่ครบถ้วนตามเงื่อนไขโปรโมชั่น</span>,
                                                    },
                                                    {
                                                        value: "ลงทะเบียนซ้ำ",
                                                        label: <span style={{ fontWeight: '300' }}>ลงทะเบียนซ้ำ</span>,
                                                    },
                                                    {
                                                        value: "รูปใบเสร็จไม่ชัดเจน",
                                                        label: <span style={{ fontWeight: '300' }}>รูปใบเสร็จไม่ชัดเจน</span>,
                                                    },
                                                    {
                                                        value: "รูป S/N ไม่ชัดเจน",
                                                        label: <span style={{ fontWeight: '300' }}>รูป S/N ไม่ชัดเจน</span>,
                                                    },
                                                    {
                                                        value: "S/N ไม่ถูกต้อง",
                                                        label: <span style={{ fontWeight: '300' }}>S/N ไม่ถูกต้อง</span>,
                                                    },
                                                    {
                                                        value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                                                        label: <span style={{ fontWeight: '300' }}>ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน</span>,
                                                    },
                                                ]}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                )}

                                {(imageList.length != 0 && !this.state.first && this.state.remark) && (
                                    <GridContainer>
                                        <GridItem xs={6} sm={5} md={5}>
                                            <Field
                                                name="reject_note"
                                                component={CustomRadio}
                                                radioLists={[
                                                    {
                                                        value: "ข้อมูลในใบกำกับภาษีไม่ครบถ้วนตามเงื่อนไขโปรโมชั่น",
                                                        label: <span style={{ fontWeight: '300' }}>ข้อมูลในใบกำกับภาษีไม่ครบถ้วนตามเงื่อนไขโปรโมชั่น aa</span>,
                                                    },
                                                    {
                                                        value: "ลงทะเบียนซ้ำ",
                                                        label: <span style={{ fontWeight: '300' }}>ลงทะเบียนซ้ำ</span>,
                                                    },
                                                    {
                                                        value: "รูปถ่ายไม่ชัดเจน หรือ รายละเอียดไม่ครบถ้วน",
                                                        label: <span style={{ fontWeight: '300' }}>รูปถ่ายไม่ชัดเจน หรือ รายละเอียดไม่ครบถ้วน</span>,
                                                    }, 
                                                    {
                                                        value: "เอกสารต้องเป็นใบกำกับภาษีอย่างย่อ/เต็ม เท่านั้น",
                                                        label: <span style={{ fontWeight: '300' }}>เอกสารต้องเป็นใบกำกับภาษีอย่างย่อ/เต็ม เท่านั้น</span>,
                                                    },
                                                    {
                                                        value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                                                        label: <span style={{ fontWeight: '300' }}>ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน</span>,
                                                    },
                                                    {
                                                        value: "ชื่อลูกค้าในใบกำกับภาษีไม่ตรงกับชื่อที่ลงทะเบียนในระบบ",
                                                        label: <span style={{ fontWeight: '300' }}>ชื่อลูกค้าในใบกำกับภาษีไม่ตรงกับชื่อที่ลงทะเบียนในระบบ</span>,
                                                    },

                                                ]}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                )}

                                {(imageList1.length != 0 && imageList2.length != 0 && this.state.first && check_reject_note) && (
                                    <GridContainer>
                                        <GridItem xs={6} sm={5} md={5}>
                                            <Field
                                                name="reject_note"
                                                component={CustomRadio}
                                                radioLists={[
                                                    {
                                                        value: "รูปภาพการติดตั้งไม่ถูกต้อง",
                                                        label: <span style={{ fontWeight: '300' }}>รูปภาพการติดตั้งไม่ถูกต้อง</span>,
                                                    },
                                                    {
                                                        value: "รูปภาพสถานที่ติดตั้งไม่ถูกต้อง",
                                                        label: <span style={{ fontWeight: '300' }}>รูปภาพสถานที่ติดตั้งไม่ถูกต้อง</span>,
                                                    },
                                                    {
                                                        value: "รูปภาพไม่ชัดเจน ไม่สามารถตรวจสอบเลข Serial Number ได้",
                                                        label: <span style={{ fontWeight: '300' }}>รูปภาพไม่ชัดเจน ไม่สามารถตรวจสอบเลข Serial Number ได้</span>,
                                                    },
                                                    {
                                                        value: "รูป S/N ไม่ชัดเจน",
                                                        label: <span style={{ fontWeight: '300' }}>รูป S/N ไม่ชัดเจน</span>,
                                                    },
                                                        {
                                                        value: "S/N ไม่ถูกต้อง",
                                                        label: <span style={{ fontWeight: '300' }}>S/N ไม่ถูกต้อง</span>,
                                                    },
                                                    {
                                                        value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                                                        label: <span style={{ fontWeight: '300' }}>ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน</span>,
                                                    },
                                                ]}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                )}

                                {(imageList1.length != 0 && imageList2.length != 0 && !this.state.first && this.state.remark) && (
                                    <GridContainer>
                                        <GridItem xs={6} sm={5} md={5}>
                                            <Field
                                                name="reject_note"
                                                component={CustomRadio}
                                                radioLists={[
                                                    {
                                                        value: "รูปภาพการติดตั้งไม่ถูกต้อง",
                                                        label: <span style={{ fontWeight: '300' }}>รูปภาพการติดตั้งไม่ถูกต้อง</span>,
                                                    },
                                                    {
                                                        value: "รูปภาพสถานที่ติดตั้งไม่ถูกต้อง",
                                                        label: <span style={{ fontWeight: '300' }}>รูปภาพสถานที่ติดตั้งไม่ถูกต้อง</span>,
                                                    },
                                                    {
                                                        value: "รูปภาพไม่ชัดเจน ไม่สามารถตรวจสอบเลข Serial Number ได้",
                                                        label: <span style={{ fontWeight: '300' }}>รูปภาพไม่ชัดเจน ไม่สามารถตรวจสอบเลข Serial Number ได้</span>,
                                                    },
                                                    {
                                                        value: "รูปภาพที่แนบมาไม่ถูกต้องตามเงื่อนไขที่กำหนด",
                                                        label: <span style={{ fontWeight: '300' }}>รูปภาพที่แนบมาไม่ถูกต้องตามเงื่อนไขที่กำหนด</span>,
                                                    },
                                                    {
                                                        value: "ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน",
                                                        label: <span style={{ fontWeight: '300' }}>ข้อมูลที่กรอกและข้อมูลรูปถ่ายไม่ตรงกัน</span>,
                                                    },
                                                ]}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                )}
                            </>
                         )}
                    </DialogContent>

                    <DialogActions
                        className={classes.modalFooter}>

                        <Button
                            id={`${FORM_NAME}_btn_submit`}
                            type="submit"
                            style={{ marginRight: "10px" }}
                            color="primary">
                            Submit
                        </Button>

                        <Button
                            id={`${FORM_NAME}_btn_cancel`}
                            type="button"
                            onClick={() => {
                                this.setState({ remark: false, first: true })
                                this.closeDialog()
                            }}
                            color="white">
                            Cancel
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    const { formOpen, earnReport, formMode } = state.report;
    const { user } = state.authentication;
    return {
        earnReport,
        formOpen,
        formMode,
        user
    };
}
const connectedComponent = connect(mapStateToProps)(EarnReportFormAura);

export default reduxForm({
    form: FORM_NAME,
    validate: validate,
    enableReinitialize: true,
    onSubmitFail: (errors) => {
        //    crmValidator.alertFirstInvalid(FORM_NAME, errors, form_validate);
    }
})(withStyles(sweetAlertStyle)(connectedComponent))


